// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 12 12%27 fill=%27none%27 stroke=%27%233b3b3b%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27><path d=%27M3 5 L6 8 L9 5%27/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========================================================================
   LlmPractice — LLM 실습 - 기본 (Figma 68:1909)
   헤더는 components/AppHeader (별도 CSS)
   ======================================================================== */

.llm {
  height: 100vh;
  background: var(--fg-bg-dark);
  font-family: var(--font-sans);
  color: var(--fg-text-basic);
  display: flex;
  flex-direction: column;
}

.llm__layout {
  flex: 1 1;
  min-height: 0;
  display: flex;
  background: var(--fg-bg-content);
  margin: 0 16px;
  border-radius: 16px 16px 0 0;
  box-shadow: 0 0 6.3px 1px rgba(0, 0, 0, 0.26);
  overflow: hidden;
}

/* ───────── 사이드바 ───────── */
.llm__sidebar {
  width: 272px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  background: var(--fg-bg-content);
  min-height: 0;
  /* flex child가 콘텐츠 넘어 늘어나지 않도록 */
  overflow: hidden;
  transition:
    width 0.28s cubic-bezier(0.4, 0, 0.2, 1),
    padding 0.28s cubic-bezier(0.4, 0, 0.2, 1),
    gap 0.28s cubic-bezier(0.4, 0, 0.2, 1);

}

/* 접힌 상태 — Figma sidebar-closed (2030:14844) */
.llm__sidebar--collapsed {
  width: 64px;
  align-items: center;
  gap: 24px;
  padding: 30px 16px;
}

/* 자식 콘텐츠 등장 부드럽게 */
.llm__sidebar>*,
.llm__sidebar--collapsed>* {
  animation: llmSidebarFadeIn 0.24s ease both;
}

@keyframes llmSidebarFadeIn {
  from {
    opacity: 0;
    transform: translateY(2px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.llm__sidebar-mini-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
}

.llm__sidebar-mini-btn {
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: var(--fg-text-basic);
  cursor: pointer;
  transition: var(--transition-fast);
}

.llm__sidebar-mini-btn:hover {
  background: rgba(0, 0, 0, 0.05);
}

.llm__sidebar-mini-btn:focus-visible {
  outline: none;
  background: rgba(0, 0, 0, 0.08);
}

.llm__sidebar-toggle {
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: var(--fg-text-basic);
  cursor: pointer;
}

.llm__sidebar-toggle:hover {
  background: rgba(0, 0, 0, 0.04);
}

.llm__sidebar-title {
  margin: 0;
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  color: var(--fg-text-basic);
}

.llm__new-chat {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 10px;
  background: var(--fg-bg-mychat);
  border: 0;
  border-radius: 12px;
  font-family: inherit;
  font-size: 15px;
  font-weight: 500;
  color: var(--fg-text-basic);
  cursor: pointer;
  transition: var(--transition-fast);
}

.llm__new-chat:hover {
  background: #d8dbed;
}

.llm__sidebar-section {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1 1;
  min-height: 0;
  /* flex child가 부모 안에서 줄어들 수 있게 (스크롤 동작 조건) */
}

.llm__sidebar-section-title {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: var(--fg-text-basic);
}

/* ───────── 검색바 ───────── */
.llm__search {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 12px 7px 16px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 30px;
}

.llm__search-input {
  flex: 1 1;
  min-width: 0;
  border: 0;
  outline: none;
  font-family: inherit;
  font-size: 15px;
  color: var(--fg-text-basic);
  background: transparent;
}

.llm__search-input::placeholder {
  color: var(--fg-text-gray);
}

.llm__search>svg {
  flex-shrink: 0;
  color: var(--fg-text-gray);
}

/* ───────── 대화 목록 ───────── */
.llm__chat-list {
  list-style: none;
  margin: 0;
  padding: 0 4px 0 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
}

/* 사이드바 채팅 목록 스크롤바 (얇고 은은하게) */
.llm__chat-list::-webkit-scrollbar {
  width: 6px;
}

.llm__chat-list::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.18);
  border-radius: 3px;
}

.llm__chat-list::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.32);
}

.llm__chat-list::-webkit-scrollbar-track {
  background: transparent;
}

.llm__chat-item {
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px;
  background: #fff;
  border: 1px solid #fff;
  border-radius: 12px;
  cursor: pointer;
  transition: var(--transition-fast);
}

.llm__chat-item:hover {
  background: #f9ffff;
  border-color: var(--fg-emr-green);
}

.llm__chat-item--active {
  background: var(--fg-bg-liteblue);
  border-color: var(--fg-button-hover);
}

.llm__chat-item--accent-green {
  background: #f9ffff;
  border-color: var(--fg-emr-green);
}

.llm__chat-trash {
  position: absolute;
  right: 8px;
  top: 8px;
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  background: #fff;
  border: 0;
  border-radius: 6px;
  color: var(--fg-text-gray);
  cursor: pointer;
  transition: var(--transition-fast);
  /* 기본은 숨김. 카드 hover 또는 active 일 때만 노출 */
  opacity: 0;
  pointer-events: none;
}

/* 카드 hover 또는 active 상태에서 삭제 버튼 노출 */
.llm__chat-item:hover .llm__chat-trash,
.llm__chat-item--active .llm__chat-trash,
.llm__chat-item--accent-green .llm__chat-trash {
  opacity: 1;
  pointer-events: auto;
}

/* 겹쳐 띄운 버튼이 제목을 가리도록 카드 상태별 배경 일치 */
.llm__chat-item:hover .llm__chat-trash {
  background: #f9ffff;
}

.llm__chat-item--active .llm__chat-trash {
  background: var(--fg-bg-liteblue);
}

.llm__chat-item--accent-green .llm__chat-trash {
  background: #f9ffff;
}

.llm__chat-item .llm__chat-trash:hover {
  background: rgba(0, 0, 0, 0.06);
  color: var(--fg-anti-red);
}

.llm__chat-icon {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  color: var(--fg-text-purple);
}

.llm__chat-icon--agent {
  color: var(--fg-button-hover);
}

.llm__chat-icon--chatbot {
  color: var(--fg-emr-green);
}

.llm__chat-body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-top: 2px;
}

.llm__chat-agent {
  margin: 0;
  font-size: 12px;
  font-weight: 500;
  color: var(--fg-text-purple);
}

.llm__chat-title {
  margin: 0;
  font-size: 15px;
  font-weight: 500;
  color: #464646;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.llm__chat-time {
  margin: 0;
  font-size: 13px;
  color: var(--fg-text-gray);
}

.llm__chat-empty {
  padding: 12px 10px;
  font-size: 14px;
  color: var(--fg-text-gray);
  text-align: center;
}

/* ───────── 메인 영역 ───────── */
.llm__main {
  flex: 1 1;
  min-width: 0;
  background: #fff;
  border-radius: 16px 16px 0 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 80px 24px 40px;
  overflow-y: auto;
}

.llm__welcome {
  width: 100%;
  max-width: 760px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  text-align: left;
  align-items: start;
}

.llm__welcome--center {
  margin: 0 auto;
  align-items: center;
  text-align: center;
  gap: 24px;
  text-align: left;
  align-items: start;
}

.llm__welcome-input {
  width: 100%;
}

.llm__main--empty .llm-chat__scroller--welcome {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
}

.llm__welcome-title {
  margin: 0;
  font-size: 36px;
  font-weight: 600;
  line-height: 46px;
  color: var(--fg-text-basic);
}

/* ───────── 채팅 입력박스 ───────── */
.llm__input-box {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  background: #fff;
  border-radius: 28px;
  box-shadow: 0 2px 7px rgba(0, 0, 0, 0.2);
}

.llm__input {
  width: 100%;
  min-height: 26px;
  max-height: 160px;
  border: 0;
  outline: none;
  resize: none;
  font-family: inherit;
  font-size: 16px;
  line-height: 26px;
  color: var(--fg-text-basic);
  background: transparent;
  overflow-y: hidden;
}

.llm__input::placeholder {
  color: var(--fg-text-gray);
}

.llm__input-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.llm__input-actions-left {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.llm__input-actions-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* ───── 첨부 요약 pill (입력창 footer 왼쪽) ───── */
.llm__attach-summary-wrap {
  position: relative;
  display: inline-flex;
  min-width: 0;
}

.llm__attach-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 10px 0 10px;
  background: var(--fg-bg-litepp);
  border: 1px solid transparent;
  border-radius: 9999px;
  color: var(--fg-text-purple);
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: var(--transition-fast);
}

.llm__attach-pill:hover {
  background: var(--fg-bg-step-active);
  border-color: var(--fg-button);
}

.llm__attach-pill--active {
  background: #fff;
  border-color: var(--fg-button);
}

.llm__attach-pill-text {
  font-weight: 500;
}

.llm__attach-pill-count {
  display: inline-grid;
  place-items: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  background: var(--fg-button);
  border-radius: 9999px;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
}

.llm__attach-pill-arrow {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: transform 160ms ease;
  color: var(--fg-text-purple);
}

.llm__attach-pill-arrow--up {
  transform: rotate(180deg);
}

.llm__icon-btn {
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  border-radius: 18px;
  color: var(--fg-text-basic);
  cursor: pointer;
  transition: var(--transition-fast);
}

.llm__icon-btn:hover {
  background: var(--fg-bg-content);
}

.llm__icon-btn--active {
  background: var(--fg-bg-content);
}

/* 웹 검색 토글 ON 상태 (Figma 59:1302 - Property 1=Variant3) */
.llm__icon-btn.llm__icon-btn--on,
.llm__icon-btn.llm__icon-btn--on:hover {
  background: var(--fg-button-hover);
  color: #fff;
}

.llm__icon-btn.llm__icon-btn--on:hover {
  filter: brightness(1.06);
}

/* ───── 파일첨부 팝오버 메뉴 (Figma 2016:15065) ───── */
.llm__attach-wrap {
  position: relative;
  display: inline-flex;
}

.attach-menu {
  position: absolute;
  bottom: calc(100% + 8px);
  left: 0;
  z-index: 80;
  width: 226px;
  padding: 20px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 6px rgba(0, 0, 0, 0.07), 0 2px 4px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  gap: 12px;
  font-family: var(--font-sans);
  animation: attach-menu-fade 120ms ease-out;
}

.attach-menu--down {
  bottom: auto;
  top: calc(100% + 8px);
}

@keyframes attach-menu-fade {
  from {
    opacity: 0;
    transform: translateY(4px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.attach-menu__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.attach-menu__item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  padding: 8px;
  background: #fff;
  border: 0;
  border-radius: 8px;
  font-family: inherit;
  text-align: left;
  cursor: pointer;
  transition: background 120ms ease;
}

.attach-menu__item:hover {
  background: var(--fg-bg-content);
}

.attach-menu__icon {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  color: var(--fg-text-basic);
}

.attach-menu__text {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.attach-menu__title {
  font-size: 15px;
  font-weight: 500;
  color: var(--fg-text-basic);
  line-height: 1;
}

.attach-menu__desc {
  font-size: 12px;
  font-weight: 400;
  color: var(--fg-text-gray);
  line-height: 1;
}

/* 모델 선택 */
.llm__model-select {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 8px 8px 16px;
  background: var(--fg-bg-card);
  border: 1px solid transparent;
  border-radius: 30px;
  font-family: inherit;
  cursor: pointer;
  transition: var(--transition-fast);
  color: var(--fg-text-basic);
}

.llm__model-select:hover {
  border-color: var(--fg-line);
  background: #fff;
}

.llm__model-label {
  font-size: 12px;
  color: var(--fg-text-basic);
}

.llm__model-name {
  font-size: 15px;
  font-weight: 500;
  color: var(--fg-text-basic);
  white-space: nowrap;
}

.llm__model-badge {
  display: inline-grid;
  place-items: center;
  min-width: 17px;
  height: 17px;
  padding: 0 4px;
  background: var(--fg-anti-red);
  border-radius: 9999px;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
}

.llm__model-select--active {
  border-color: var(--fg-line);
  background: #fff;
}

.llm__model-arrow {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: transform 160ms ease;
}

.llm__model-arrow--up {
  transform: rotate(180deg);
}

/* ───── 모델 선택 모달 (popover) ───── */
.llm__model-select-wrap {
  position: relative;
  display: inline-flex;
}

.model-picker {
  /* Portal로 document.body 직속 렌더 + 인라인 style로 top/left/width/maxHeight 주입.
     position/좌표/사이즈는 ModelPickerModal.js의 computePopoverPosition()가 결정. */
  position: fixed;
  z-index: 80;
  overflow-y: auto;
  padding: 20px;
  background: var(--fg-bg-card);
  border-radius: 16px;
  box-shadow: 0 8px 12px rgba(0, 0, 0, 0.07), 0 2px 4px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  gap: 20px;
  font-family: var(--font-sans);
  animation: model-picker-fade 120ms ease-out;
}

@keyframes model-picker-fade {
  from {
    opacity: 0;
    transform: translateY(4px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.model-picker__warning {
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  color: var(--fg-anti-red);
}

.model-picker__empty {
  margin: 0;
  padding: 16px 4px;
  font-size: 13px;
  font-weight: 400;
  color: var(--fg-secondary, #6b7280);
  text-align: center;
}

.model-picker__group {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.model-picker__group-head {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 24px;
}

.model-picker__group-title {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  color: var(--fg-text-basic);
}

.model-picker__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.model-picker__item {
  min-width: 0;
}

.model-picker__row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  min-height: 32px;
  padding: 6px 4px;
  background: transparent;
  border: 0;
  border-radius: 6px;
  font-family: inherit;
  text-align: left;
  cursor: pointer;
  transition: background 120ms ease;
}

.model-picker__row:hover {
  background: rgba(0, 0, 0, 0.04);
}

.model-picker__row--disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.model-picker__row--disabled:hover {
  background: transparent;
}

.model-picker__check {
  flex-shrink: 0;
  align-self: flex-start;
  margin-top: 2px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 4px;
  background: #c2c2c2;
  color: #fff;
  transition: background 120ms ease;
}

.model-picker__check--on {
  background: var(--fg-button);
}

.model-picker__name {
  flex: 1 1 auto;
  min-width: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.35;
  color: var(--fg-text-basic);
  word-break: break-word;
  overflow-wrap: anywhere;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.model-picker__type {
  flex-shrink: 0;
  align-self: flex-start;
  margin-top: 2px;
  font-size: 12px;
  font-weight: 400;
  color: var(--fg-text-gray);
}

/* 전송 버튼 */
.llm__send-btn {
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  padding: 0;
  background: transparent;
  border: 0;
  cursor: pointer;
  color: var(--fg-button);
  transition: var(--transition-fast);
}

.llm__send-btn:hover {
  color: var(--fg-button-hover);
}

/* ───────── 추천 카드 ───────── */
.llm__suggestions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  width: 100%;
}

.llm__suggestion {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 4px;
  padding: 12px 20px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 12px;
  text-align: left;
  font-family: inherit;
  cursor: pointer;
  transition: var(--transition-fast);
}

.llm__suggestion:hover {
  background: var(--fg-bg-cooler);
  border-color: var(--fg-button);
}

.llm__suggestion-body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.llm__suggestion-title {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: var(--fg-text-basic);
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.llm__suggestion-summary {
  margin: 0;
  font-size: 14px;
  color: var(--fg-text-gray);
  line-height: 1.4;
}

.llm__suggestion-tag {
  flex-shrink: 0;
  padding: 4px;
  background: var(--fg-bg-warning);
  border-radius: 4px;
  font-size: 12px;
  color: var(--fg-anti-red);
  white-space: nowrap;
}

/* ───────── 반응형 ───────── */

/* ========================================================================
   LlmChat — 대화 진행 화면 (Figma 68:3839)
   ======================================================================== */

.llm__main--chat {
  padding: 0;
  background: #fff;
  border-radius: 16px 16px 0 0;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  overflow: hidden;
  min-height: 0;
}

/* 상단 툴바 */
.llm-chat__toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  background: var(--fg-bg-toolbar);
  border-radius: 16px 16px 0 0;
  border-bottom: 1px solid var(--fg-line);
  flex-shrink: 0;
}

.llm-chat__toolbar-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.llm-chat__toolbar-back {
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: var(--fg-text-menu);
  cursor: pointer;
}

.llm-chat__toolbar-back:hover {
  background: rgba(0, 0, 0, 0.04);
}

/* 대화목록 열기 버튼 — 모바일 전용(데스크탑 숨김) */
.llm-chat__mobile-menu { display: none; }
.llm-chat__toolbar-menu {
  display: none;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: var(--fg-text-menu);
  cursor: pointer;
}
.llm-chat__toolbar-menu:hover { background: rgba(0, 0, 0, 0.04); }

.llm-chat__toolbar-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: var(--fg-text-basic);
  line-height: 26px;
}

.llm-chat__toolbar-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.llm-chat__toolbar-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 5px 7px 7px;
  background: var(--fg-bg-litepp);
  border: 0;
  border-radius: 4px;
  color: var(--fg-button-hover);
  cursor: pointer;
  transition: var(--transition-fast);
}

.llm-chat__toolbar-btn:hover {
  background: #d8dbed;
}

.llm-chat__toolbar-model-dot {
  width: 14px;
  height: 14px;
  border-radius: 9999px;
  background: var(--gpt-color, #10a37f);
}

/* 스크롤 영역 */
.llm-chat__scroller {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  padding: 40px 24px 200px;
}

.llm-chat__messages {
  max-width: 760px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 40px;
}

/* 메시지 공통 */
.llm-chat__msg {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.llm-chat__msg--user {
  align-items: flex-end;
}

.llm-chat__msg--assistant {
  align-items: flex-start;
}

.llm-chat__bubble {
  max-width: 700px;
  padding: 12px 16px;
  font-size: 16px;
  line-height: 26px;
  color: var(--fg-text-basic);
}

.llm-chat__bubble--user {
  background: var(--fg-bg-mychat);
  border-radius: 16px 16px 0 16px;
}

.llm-chat__bubble p {
  margin: 0;
  white-space: pre-wrap;
}

/* 어시스턴트 마크다운 */
.llm-chat__markdown {
  width: 100%;
  font-size: 16px;
  line-height: 26px;
  color: var(--fg-text-basic);
}

/* 어시스턴트 메시지에 첨부되는 생성 이미지 */
.llm-chat__images {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
  width: 100%;
}

.llm-chat__image {
  max-width: 100%;
  max-height: 400px;
  border-radius: var(--radius-md, 8px);
  border: 1px solid var(--fg-border, rgba(0, 0, 0, 0.08));
  cursor: pointer;
  object-fit: contain;
  transition: transform 120ms ease, box-shadow 120ms ease;
}

.llm-chat__image:hover {
  transform: scale(1.02);
  box-shadow: var(--shadow-md, 0 4px 12px rgba(0, 0, 0, 0.08));
}

.llm-chat__markdown h1 {
  font-size: 36px;
  font-weight: 600;
  line-height: 46px;
  margin: 0 0 20px;
}

.llm-chat__markdown h2 {
  font-size: 36px;
  font-weight: 600;
  line-height: 46px;
  margin: 24px 0 16px;
}

.llm-chat__markdown h3 {
  font-size: 18px;
  font-weight: 600;
  line-height: 28px;
  margin: 20px 0 12px;
}

.llm-chat__markdown h4 {
  font-size: 16px;
  font-weight: 600;
  line-height: 26px;
  margin: 16px 0 8px;
}

.llm-chat__markdown p {
  margin: 0 0 16px;
}

.llm-chat__markdown ul,
.llm-chat__markdown ol {
  padding-left: 12px;
  margin: 0 0 16px;
}

.llm-chat__markdown li {
  margin: 0 0 10px;
  padding-left: 8px;
  list-style: none;
  position: relative;
}

.llm-chat__markdown li::before {
  content: '';
  position: absolute;
  left: -4px;
  top: 11px;
  width: 4px;
  height: 4px;
  background: var(--fg-text-basic);
  border-radius: 9999px;
}

.llm-chat__markdown table {
  border-collapse: collapse;
  border: 1px solid var(--fg-line);
  width: 100%;
  margin: 0 0 16px;
}

.llm-chat__markdown th,
.llm-chat__markdown td {
  padding: 8px;
  border-left: 1px solid var(--fg-line);
  border-top: 1px solid var(--fg-line);
  text-align: left;
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
}

.llm-chat__markdown th {
  background: rgba(0, 0, 0, 0.06);
}

.llm-chat__markdown blockquote {
  margin: 0 0 16px;
  padding: 12px 12px 12px 20px;
  background: var(--fg-bg-liteblue);
  border-left: 3px solid var(--fg-blue-lite);
  border-radius: 12px;
}

.llm-chat__markdown blockquote p {
  margin: 0;
}

.llm-chat__markdown a {
  color: var(--fg-link);
  text-decoration: underline;
}

.llm-chat__markdown a:hover {
  color: var(--fg-link-hover);
}

.llm-chat__markdown hr {
  border: 0;
  border-top: 1px solid var(--fg-line);
  margin: 24px 0;
}

.llm-chat__markdown code {
  font-family: ui-monospace, 'SF Mono', Consolas, monospace;
  font-size: 14px;
  padding: 2px 4px;
  background: rgba(0, 0, 0, 0.04);
  border-radius: 4px;
}

.llm-chat__markdown pre {
  background: #f6f8ff;
  border: 1px solid var(--fg-line);
  border-radius: 8px;
  padding: 12px 16px;
  overflow-x: auto;
  margin: 0 0 16px;
}

.llm-chat__markdown pre code {
  background: transparent;
  padding: 0;
}

/* 메시지 액션 */
.llm-chat__msg-actions {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  align-self: flex-end;
}

.llm-chat__msg-action {
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  padding: 2px;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: var(--fg-text-basic);
  cursor: pointer;
  transition: var(--transition-fast);
}

.llm-chat__msg-action:hover {
  background: rgba(0, 0, 0, 0.04);
}

.llm-chat__msg-time {
  font-size: 12px;
  color: var(--fg-text-gray);
  margin-left: 4px;
}

/* 입력박스 영역 (스크롤 위에 sticky bottom) */
.llm-chat__input-area {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  padding: 40px 16px 20px;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.7) 30%, #fff 100%);
  pointer-events: none;
}

.llm-chat__input-area>* {
  pointer-events: auto;
  width: 100%;
  max-width: 760px;
}

/* ========================================================================
   LlmChatMulti — 다중 모델 비교 (Figma 82:5718)
   ======================================================================== */

.llm__main--multi {
  padding: 0;
}

.llm-multi__toolbar-model {
  width: 32px;
  padding: 0;
  display: grid;
  place-items: center;
}

.llm-multi__toolbar-model {
  border-radius: 8px;
  transition:
    opacity var(--transition-fast),
    background var(--transition-fast),
    box-shadow var(--transition-fast);
}

/* 3컬럼 가로 분할 + 가로 스크롤 */
.llm-multi__columns {
  flex: 1 1;
  min-height: 0;
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
}

.llm-multi__col-wrapper {
  flex: 1 1;
  min-width: 480px;
  display: flex;
  flex-direction: column;
  border-right: 1px solid var(--fg-line);
}

.llm-multi__col-wrapper:last-child {
  border-right: 0;
}

.llm-multi__col-scroller {
  flex: 1 1;
  overflow-y: auto;
  padding: 0 30px 200px;
  position: relative;
}

.llm-multi__column {
  display: flex;
  flex-direction: column;
  padding-top: 0;
}

/* sticky 모델 칩 — col-body 위에 겹쳐 떠있고, 메시지가 그 뒤로 통과(그라디언트로 페이드) */
.llm-multi__col-head {
  position: sticky;
  top: 0;
  z-index: 4;
  margin: 0 -30px -82px;
  padding: 20px 30px 30px;
  display: flex;
  justify-content: center;
  background: linear-gradient(to top, rgba(255, 255, 255, 0) 0%, #fff 70%);
  pointer-events: none;
}

.llm-multi__model-chip {
  pointer-events: auto;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 5px 6px;
  background: var(--fg-text-basic);
  border-radius: 30px;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.29);
  opacity: 0;
  transition: opacity 0.18s ease;
}

/* 컬럼 호버/포커스 시에만 모델 칩 노출 (에이전트 채팅 floating-toolbar 패턴) */
.llm-multi__col-wrapper:hover .llm-multi__model-chip,
.llm-multi__col-wrapper:focus-within .llm-multi__model-chip {
  opacity: 1;
}

.llm-multi__model-chip-info {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 0 5px;
}

.llm-multi__model-chip-name {
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  white-space: nowrap;
}

.llm-multi__model-chip-close {
  display: inline-grid;
  place-items: center;
  width: 32px;
  height: 32px;
  padding: 0 6px;
  background: transparent;
  border: 0;
  border-radius: 30px;
  color: rgba(255, 255, 255, 0.6);
  cursor: pointer;
  transition: var(--transition-fast);
}

.llm-multi__model-chip-close:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.1);
}

.llm-multi__col-body {
  /* 모델 칩이 호버 시에만 floating overlay 로 노출되므로 첫 메시지를 윗단으로 끌어올림.
     호버 시 칩은 col-head 의 sticky + linear-gradient 페이드로 메시지 위에 겹친다. */
  padding-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 40px;
}

/* multi 컬럼 내 메시지는 한 컬럼 폭 내에서 좁게 */
.llm-multi__column .llm-chat__bubble--user {
  max-width: 100%;
}

.llm-multi__column .llm-chat__markdown h1,
.llm-multi__column .llm-chat__markdown h2 {
  font-size: 28px;
  line-height: 38px;
}

@media (max-width: 1280px) {
  .llm-multi__col-wrapper {
    min-width: 380px;
  }
}

/* 멀티 컬럼: 메시지 없을 때 placeholder */
.llm-multi__col-empty {
  display: flex;
  flex: 1 1;
  align-items: center;
  justify-content: center;
  min-height: 240px;
  padding: 32px 16px;
}

.llm-multi__col-empty-text {
  text-align: center;
  color: var(--text-secondary, #9ca3af);
  font-size: 14px;
  line-height: 22px;
  margin: 0;
}

/* ════════════════════════════════════════════════════════════
   모바일 (≤768px) — 단일 모델 채팅으로 좁힘
   · 사이드바: 기본 접힘(레일), 펼치면 오버레이 드로어
   · 멀티 컬럼(레거시 세션): 한 모델씩 가로 스냅 스와이프
   ════════════════════════════════════════════════════════════ */
@media (max-width: 768px) {
  /* 카드 셸 좌우 여백 제거 — 채팅 본문 풀폭 + 플로팅 버튼 기준점 */
  .llm__layout { margin: 0; border-radius: 0; position: relative; }

  /* 펼친 사이드바 = 화면 위로 덮는 드로어 (+ 큰 spread 그림자로 스크림) */
  .llm__sidebar {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    width: 84vw;
    max-width: 320px;
    z-index: 200;
    border-radius: 0;
    box-shadow: 0 0 0 100vw rgba(14, 27, 43, 0.4), 8px 0 24px rgba(0, 0, 0, 0.18);
  }
  /* 접힘 = 레일 숨김(프롬프트처럼 풀폭). 대화목록은 버튼으로 여는 드로어로 접근 */
  .llm__sidebar--collapsed { display: none; }

  /* 대화목록 열기 버튼 노출 — 웰컴(플로팅) / 채팅(툴바) */
  .llm-chat__mobile-menu {
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 60;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 12px;
    background: #fff;
    border: 1px solid var(--fg-line);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
    color: var(--fg-text-basic);
    cursor: pointer;
  }
  .llm-chat__toolbar-menu { display: inline-flex; }

  /* 메인 · 웰컴 — 좌우 패딩 최소화(폭 확보) */
  .llm__main { padding: 20px 10px 28px; }
  .llm__welcome-title { font-size: 23px; line-height: 31px; }
  /* 모바일 — 예시(추천) 메시지 숨김 */
  .llm__suggestions { display: none; }
  .llm__main--empty .llm-chat__scroller--welcome { padding: 24px 10px; }

  /* 입력창 — 화면 가득 + 컴팩트(폰트·버튼 축소) */
  .llm-chat__input-area { padding: 14px 8px 8px; }
  .llm-chat__input-area > * { max-width: 100%; }
  .llm__input-box { padding: 10px 12px; border-radius: 18px; gap: 8px; }
  .llm__input { font-size: 16px; line-height: 22px; } /* 16px: iOS 포커스 줌 방지 */
  .llm__input-actions { gap: 4px; }
  .llm__input-actions-left,
  .llm__input-actions-right { gap: 4px; }
  .llm__icon-btn { width: 30px; height: 30px; border-radius: 15px; }
  .llm__icon-btn svg { width: 18px; height: 18px; }
  /* 'LLM 모델' 캡션 숨김 + 모델 셀렉트 축소 + 모델명 말줄임 */
  .llm__model-label { display: none; }
  .llm__model-select { padding: 5px 7px 5px 10px; gap: 4px; }
  .llm__model-name {
    font-size: 13px;
    max-width: 88px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .llm__model-badge { min-width: 15px; height: 15px; font-size: 10px; }
  .llm__attach-pill { height: 28px; font-size: 12px; }
  /* 전송 = 채워진 원형 버튼(컴팩트) */
  .llm__send-btn {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: var(--fg-button);
    color: #fff;
  }
  .llm__send-btn svg { width: 18px; height: 18px; }
  .llm__send-btn:hover { background: var(--fg-button-hover); color: #fff; }

  /* 사용자 말풍선 폭 확대 */
  .llm-chat__bubble--user { max-width: 90%; }

  /* 툴바 */
  .llm-chat__toolbar { padding: 10px 12px; }

  /* 멀티 컬럼(레거시 세션) — 한 모델씩 가로 스냅 스와이프 */
  .llm-multi__columns { scroll-snap-type: x mandatory; }
  .llm-multi__col-wrapper {
    flex: 0 0 100%;
    min-width: 100%;
    scroll-snap-align: start;
  }
  .llm-multi__col-scroller { padding: 0 16px 180px; }
  /* 모바일엔 호버가 없으므로 모델 칩 상시 노출 */
  .llm-multi__col-wrapper .llm-multi__model-chip { opacity: 1; }

  /* 모바일 멀티 모드 — 헤더 프로바이더 아이콘이 컬럼 전환 탭으로 동작.
     한 번에 한 컬럼만 보이므로 비활성은 흐리게, 보이는 모델만 또렷하게 강조 */
  .llm-multi__toolbar-model { opacity: 0.4; }
  .llm-multi__toolbar-model--active {
    opacity: 1;
    background: var(--fg-bg-litepp);
    box-shadow: inset 0 0 0 1.5px var(--fg-button);
  }
}

/* ============================================================
 *  파일첨부 모달 (템플릿 / 지식베이스 / 프로젝트 공통 셸)
 *  - 신규 디자인 토큰(fg-*) 기반, 라이트 테마
 * ============================================================ */
/* ============================================================
 *  Attach Modal — LLM 실습 + 메뉴 모달 공통 셸 (Figma 2047:12809)
 * ============================================================ */
.attach-modal__overlay {
  position: fixed;
  inset: 0;
  z-index: 200;
  background: rgba(15, 17, 28, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  animation: attach-modal-fade-in 140ms ease-out;
}

@keyframes attach-modal-fade-in {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.attach-modal {
  width: 100%;
  max-width: 640px;
  max-height: min(90vh, 800px);
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 7px rgba(0, 0, 0, 0.2);
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  overflow: hidden;
  font-family: var(--font-sans);
  animation: attach-modal-pop 160ms ease-out;
}

.attach-modal--template {
  max-width: min(1336px, calc(100vw - 40px));
}

/* 검색 리스트형 첨부 모달 — 검색 결과 수에 따라 높이가 출렁이지 않게 최대 높이로 고정 */
.attach-modal--fixed-height {
  height: min(90vh, 800px);
}

.attach-modal--settings {
  max-width: 560px;
}

@keyframes attach-modal-pop {
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.985);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* ───── header ───── */
.attach-modal__header {
  display: flex;
  align-items: center;
  gap: 4px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--fg-line);
  flex-shrink: 0;
}

/* figma 시안에서 헤더의 컬러 카테고리 아이콘은 제거됨 — 기존 마크업 호환을 위해 클래스는 보존하되 숨김 처리 */
.attach-modal__header-icon,
.attach-modal__header-icon--purple,
.attach-modal__header-icon--green {
  display: none;
}

.attach-modal__header-text {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.attach-modal__title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  line-height: 28px;
  color: var(--fg-text-basic);
}

.attach-modal__subtitle {
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  color: var(--fg-text-basic);
  line-height: 1.4;
}

.attach-modal__close {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  padding: 2px;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: var(--fg-text-basic);
  cursor: pointer;
  transition: var(--transition-fast);
}

.attach-modal__close:hover {
  background: var(--fg-bg-content);
}

/* ───── tabs (template only) — Figma 2047:12880 ───── */
.attach-modal__tabs {
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--fg-line);
  flex-shrink: 0;
  width: 100%;
}

.attach-modal__tab {
  flex: 1 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 10px;
  background: transparent;
  border: 0;
  border-bottom: 3px solid transparent;
  font-family: inherit;
  font-size: 15px;
  font-weight: 500;
  color: var(--fg-text-basic);
  cursor: pointer;
  transition: border-color 120ms ease;
  margin-bottom: -1px;
}

.attach-modal__tab:hover:not(.attach-modal__tab--active) {
  border-bottom-color: var(--fg-line);
}

.attach-modal__tab--active {
  border-bottom-color: var(--fg-text-basic);
}

.attach-modal__tab-count {
  display: inline-flex;
  align-items: center;
  font-size: 13px;
  font-weight: 400;
  color: var(--fg-text-gray);
  line-height: 1;
}

/* ───── toolbar (search + sort) ───── */
.attach-modal__toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.attach-modal__search {
  flex: 1 1;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 12px 7px 20px;
  background: #ffffff;
  border: 1px solid var(--fg-line);
  border-radius: 30px;
  color: var(--fg-text-gray);
  transition: var(--transition-fast);
}

.attach-modal__search:focus-within {
  border-color: var(--fg-text-basic);
}

.attach-modal__search input {
  flex: 1 1;
  min-width: 0;
  border: 0;
  outline: 0;
  background: transparent;
  font-family: inherit;
  font-size: 16px;
  line-height: 26px;
  color: var(--fg-text-basic);
}

.attach-modal__search input::placeholder {
  color: var(--fg-text-gray);
}

.attach-modal__sort {
  position: relative;
  flex-shrink: 0;
}

.attach-modal__sort select {
  appearance: none;
  -webkit-appearance: none;
  width: 122px;
  padding: 8px 32px 8px 16px;
  background: #ffffff url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat right 8px center;
  border: 1px solid var(--fg-line);
  border-radius: 8px;
  font-family: inherit;
  font-size: 16px;
  line-height: 26px;
  color: var(--fg-text-basic);
  cursor: pointer;
  transition: var(--transition-fast);
}

.attach-modal__sort select:hover {
  border-color: var(--fg-text-basic);
}

/* ───── body ───── */
.attach-modal__body {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.attach-modal__empty {
  padding: 40px 12px;
  text-align: center;
  font-size: 14px;
  color: var(--fg-text-gray);
  list-style: none;
}

/* ───── upload / selected tags ───── */
.attach-modal__upload {
  flex-shrink: 0;
}

.attach-modal__tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 12px;
  background: var(--fg-bg-liteblue);
  border-radius: 12px;
  flex-shrink: 0;
}

.attach-modal__tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 6px 4px 10px;
  background: #ffffff;
  border: 1px solid var(--fg-bg-litepp);
  border-radius: 9999px;
  font-size: 12px;
  color: var(--fg-text-basic);
  max-width: 240px;
}

.attach-modal__tag> :not(button) {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.attach-modal__tag-remove {
  display: inline-grid;
  place-items: center;
  width: 18px;
  height: 18px;
  background: transparent;
  border: 0;
  border-radius: 9999px;
  color: var(--fg-text-gray);
  cursor: pointer;
  transition: var(--transition-fast);
}

.attach-modal__tag-remove:hover {
  background: var(--fg-bg-content);
  color: var(--fg-anti-red);
}

/* ───── footer ───── */
.attach-modal__footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding-top: 12px;
  flex-shrink: 0;
}

.attach-modal__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 42px;
  padding: 6px 12px;
  background: var(--fg-text-gray);
  border: 0;
  border-radius: 12px;
  font-family: inherit;
  font-size: 16px;
  font-weight: 700;
  line-height: 1;
  color: #ffffff;
  cursor: pointer;
  transition: background 120ms ease, transform 120ms ease;
}

.attach-modal__btn svg {
  display: block;
}

.attach-modal__btn:hover:not(:disabled) {
  background: #6f6f6f;
}

.attach-modal__btn--primary {
  background: var(--fg-button);
}

.attach-modal__btn--primary:hover:not(:disabled) {
  background: var(--fg-button-hover);
}

.attach-modal__btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.attach-modal__footer--split {
  justify-content: space-between;
}

.attach-modal__footer-right {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

/* ============================================================
 *  상세 설정 (튜닝) 모달 — 프리셋 + 슬라이더 (Figma 2047:12831 / 2047:12836)
 * ============================================================ */
.tuning-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.tuning-section__title {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: var(--fg-text-basic);
  display: flex;
  align-items: center;
  gap: 8px;
}

.tuning-section__hint {
  margin: 0;
  font-size: 14px;
  color: var(--fg-text-gray);
  line-height: 1.4;
}

.tuning-section__hint b {
  color: var(--fg-text-basic);
  font-weight: 600;
}

.tuning-presets {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}

.tuning-preset {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 16px;
  background: var(--fg-bg-card);
  border: 1px solid var(--fg-line);
  border-radius: 12px;
  font-family: inherit;
  text-align: center;
  cursor: pointer;
  transition: border-color 120ms ease, background 120ms ease, color 120ms ease;
}

.tuning-preset:hover {
  background: var(--fg-bg-card);
  border-color: var(--fg-text-basic);
}

.tuning-preset--active {
  background: #ffffff;
  border-color: var(--fg-text-basic);
}

.tuning-preset__name {
  font-size: 15px;
  font-weight: 600;
  line-height: 26px;
  color: var(--fg-text-gray);
}

.tuning-preset:hover .tuning-preset__name,
.tuning-preset--active .tuning-preset__name {
  color: var(--fg-text-basic);
}

.tuning-preset__value {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: var(--fg-text-gray);
}

.tuning-slider {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.tuning-slider__header {
  display: grid;
  grid-template-columns: 160px 1fr 60px;
  gap: 20px;
  align-items: center;
}

.tuning-slider__label {
  font-size: 15px;
  font-weight: 600;
  line-height: 28px;
  color: var(--fg-text-basic);
}

.tuning-slider__value {
  font-size: 18px;
  font-weight: 600;
  line-height: 28px;
  color: var(--fg-text-basic);
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.tuning-slider__input {
  appearance: none;
  width: 100%;
  height: 4px;
  margin: 0;
  background: var(--fg-line);
  border-radius: 9999px;
  outline: none;
  cursor: pointer;
}

.tuning-slider__input::-webkit-slider-runnable-track {
  height: 4px;
  border-radius: 9999px;
  background: transparent;
}

.tuning-slider__input::-moz-range-track {
  height: 4px;
  border-radius: 9999px;
  background: var(--fg-line);
}

.tuning-slider__input::-moz-range-progress {
  height: 4px;
  border-radius: 9999px;
  background: var(--fg-bg-litepp-hover);
}

.tuning-slider__input::-webkit-slider-thumb {
  appearance: none;
  width: 24px;
  height: 24px;
  margin-top: -10px;
  background: var(--fg-button);
  border: 3px solid #ffffff;
  border-radius: 50%;
  box-shadow: 0 2px 6px rgba(115, 98, 194, 0.35);
  cursor: pointer;
  -webkit-transition: transform 120ms ease;
  transition: transform 120ms ease;
}

.tuning-slider__input::-webkit-slider-thumb:hover {
  transform: scale(1.08);
}

.tuning-slider__input::-moz-range-thumb {
  width: 24px;
  height: 24px;
  background: var(--fg-button);
  border: 3px solid #ffffff;
  border-radius: 50%;
  box-shadow: 0 2px 6px rgba(115, 98, 194, 0.35);
  cursor: pointer;
}

.tuning-slider__desc {
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  color: var(--fg-text-gray);
  line-height: 1.4;
}

/* ============================================================
 *  list 스타일 (지식베이스 / 프로젝트) — Figma 2047:12820 / 2047:12827
 * ============================================================ */
.attach-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.attach-list__item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
  padding: 16px 20px;
  background: #ffffff;
  border: 1px solid var(--fg-line);
  border-radius: 12px;
  font-family: inherit;
  text-align: left;
  cursor: pointer;
  transition: border-color 120ms ease, background 120ms ease;
}

.attach-list__item:hover:not(:disabled),
.attach-list__item--selected {
  border-color: var(--fg-text-basic);
  background: #ffffff;
}

.attach-list__item--disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.attach-list__check {
  flex-shrink: 0;
  display: inline-grid;
  place-items: center;
  width: 16px;
  height: 16px;
  margin-top: 6px;
  background: #ffffff;
  border: 1.5px solid var(--fg-line);
  border-radius: 4px;
  color: #ffffff;
  transition: var(--transition-fast);
}

.attach-list__check--on {
  background: var(--fg-side-hover);
  border-color: var(--fg-side-hover);
}

.attach-list__icon {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  border-radius: 8px;
  background: var(--fg-bg-content);
  color: var(--fg-text-basic);
}

.attach-list__icon--green {
  background: var(--fg-bg-tag-lime);
  color: var(--fg-class-green);
}

.attach-list__color {
  flex-shrink: 0;
  width: 4px;
  align-self: stretch;
  border-radius: 4px;
  background: var(--fg-button);
}

.attach-list__info {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.attach-list__name {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  line-height: 28px;
  color: var(--fg-text-basic);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.attach-list__meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  font-weight: 400;
  color: var(--fg-text-gray);
  line-height: 1.2;
}

.attach-list__meta-divider {
  display: inline-block;
  width: 1px;
  height: 14px;
  background: var(--fg-line);
  margin: 0 4px;
}

.attach-list__badge {
  display: inline-flex;
  align-items: center;
  padding: 1px 6px;
  background: var(--fg-bg-content);
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  color: var(--fg-text-gray);
}

/* ============================================================
 *  Template grid 스타일 (Figma 2047:12874)
 * ============================================================ */
.attach-template__hint {
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  color: var(--fg-text-basic);
  line-height: 1.4;
}

.attach-template__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.attach-template__card {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px 20px;
  background: #ffffff;
  border: 1px solid var(--fg-line);
  border-radius: 12px;
  font-family: inherit;
  text-align: left;
  cursor: pointer;
  transition: border-color 120ms ease, background 120ms ease;
}

.attach-template__card:hover,
.attach-template__card--selected {
  border-color: var(--fg-text-basic);
  background: #ffffff;
}

.attach-template__check {
  flex-shrink: 0;
  display: inline-grid;
  place-items: center;
  width: 16px;
  height: 16px;
  margin-top: 6px;
  background: #ffffff;
  border: 1.5px solid var(--fg-line);
  border-radius: 4px;
  color: #ffffff;
  transition: var(--transition-fast);
}

.attach-template__check--on {
  background: var(--fg-side-hover);
  border-color: var(--fg-side-hover);
}

.attach-template__card-body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.attach-template__card-head {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
}

.attach-template__card-name {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  line-height: 28px;
  color: var(--fg-text-basic);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.attach-template__card-meta {
  font-size: 13px;
  font-weight: 400;
  color: var(--fg-text-gray);
  line-height: 1.2;
}

.attach-template__card-content {
  display: flex;
  flex-direction: column;
  gap: 0;
  width: 100%;
}

.attach-template__card-desc {
  margin: 0;
  font-size: 15px;
  font-weight: 400;
  line-height: 24px;
  color: var(--fg-text-basic);
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.attach-template__preview {
  margin: 0;
  height: 160px;
  padding: 12px;
  background: var(--fg-bg-stepper-inactive);
  border-radius: 8px;
  font-size: 15px;
  font-weight: 400;
  line-height: 24px;
  color: var(--fg-text-gray);
  overflow-x: clip;
  overflow-y: auto;
  word-break: break-word;
}

/* fewshot 카드 */
.attach-template__fewshot {
  display: flex;
  flex-direction: column;
  gap: 0;
  width: 100%;
}

.attach-template__fewshot-row {
  display: flex;
  flex-direction: column;
  gap: 0;
  width: 100%;
}

.attach-template__fewshot-label {
  font-size: 15px;
  font-weight: 400;
  line-height: 24px;
  color: var(--fg-text-basic);
}

.attach-template__fewshot-text {
  margin: 0;
  height: 140px;
  padding: 12px;
  background: var(--fg-bg-stepper-inactive);
  border-radius: 8px;
  font-size: 15px;
  font-weight: 400;
  line-height: 24px;
  color: var(--fg-text-gray);
  overflow-x: clip;
  overflow-y: auto;
  word-break: break-word;
}

/* ============================================================
 *  첨부 요약 드롭다운 (입력창 내부 pill 클릭 시)
 * ============================================================ */
.attachment-summary {
  position: absolute;
  bottom: calc(100% + 8px);
  left: 0;
  z-index: 80;
  width: 360px;
  max-width: calc(100vw - 48px);
  max-height: min(60vh, 460px);
  padding: 8px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 12px 24px rgba(15, 17, 28, 0.12), 0 2px 4px rgba(15, 17, 28, 0.06);
  display: flex;
  flex-direction: column;
  font-family: var(--font-sans);
  animation: attach-menu-fade 120ms ease-out;
  overflow: hidden;
}

.attachment-summary--down {
  bottom: auto;
  top: calc(100% + 8px);
}

.attachment-summary__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 12px;
  border-bottom: 1px solid var(--fg-line);
}

.attachment-summary__head-title {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: var(--fg-text-basic);
}

.attachment-summary__head-count {
  display: inline-grid;
  place-items: center;
  min-width: 18px;
  height: 18px;
  padding: 0 6px;
  background: var(--fg-bg-litepp);
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 700;
  color: var(--fg-text-purple);
  line-height: 1;
}

.attachment-summary__clear {
  background: transparent;
  border: 0;
  font-family: inherit;
  font-size: 12px;
  color: var(--fg-text-gray);
  cursor: pointer;
  padding: 4px 6px;
  border-radius: 6px;
  transition: var(--transition-fast);
}

.attachment-summary__clear:hover {
  background: var(--fg-bg-content);
  color: var(--fg-anti-red);
}

.attachment-summary__list {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  padding: 8px 4px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.attachment-summary__section-title {
  padding: 6px 8px 4px;
  font-size: 11px;
  font-weight: 600;
  color: var(--fg-text-gray);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.attachment-summary__item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 8px;
  border-radius: 8px;
  transition: background 120ms ease;
}

.attachment-summary__item:hover {
  background: var(--fg-bg-content);
}

.attachment-summary__icon {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  border-radius: 6px;
  background: var(--fg-bg-litepp);
  color: var(--fg-text-purple);
}

.attachment-summary__item--knowledge .attachment-summary__icon {
  background: var(--fg-bg-tag-lime);
  color: var(--fg-class-green);
}

.attachment-summary__item--file .attachment-summary__icon {
  background: var(--fg-bg-warm);
  color: var(--fg-orange-warn);
}

.attachment-summary__item--uploading .attachment-summary__icon {
  background: var(--fg-bg-content);
  color: var(--fg-text-gray);
}

.attachment-summary__item--project .attachment-summary__icon {
  background: var(--fg-bg-step-active);
  color: var(--fg-text-purple);
}

.attachment-summary__info {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.attachment-summary__name {
  margin: 0;
  font-size: 13px;
  font-weight: 500;
  color: var(--fg-text-basic);
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.attachment-summary__meta {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  color: var(--fg-text-gray);
}

.attachment-summary__type {
  display: inline-flex;
  align-items: center;
  padding: 1px 6px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.02em;
}

.attachment-summary__type--template {
  background: var(--fg-bg-litepp);
  color: var(--fg-text-purple);
}

.attachment-summary__type--knowledge {
  background: var(--fg-bg-tag-lime);
  color: var(--fg-class-green);
}

.attachment-summary__type--file {
  background: var(--fg-bg-warm);
  color: var(--fg-orange-warn);
}

.attachment-summary__type--uploading {
  background: var(--fg-bg-content);
  color: var(--fg-text-gray);
}

.attachment-summary__type--project {
  background: var(--fg-button);
  color: #fff;
}

.attachment-summary__remove {
  flex-shrink: 0;
  display: inline-grid;
  place-items: center;
  width: 24px;
  height: 24px;
  background: transparent;
  border: 0;
  border-radius: 6px;
  color: var(--fg-text-gray);
  cursor: pointer;
  transition: var(--transition-fast);
}

.attachment-summary__remove:hover {
  background: var(--fg-bg-content);
  color: var(--fg-anti-red);
}

.attachment-summary__empty {
  padding: 24px 12px;
  text-align: center;
  font-size: 12px;
  color: var(--fg-text-gray);
}`, "",{"version":3,"sources":["webpack://./src/css/LlmPractice.css"],"names":[],"mappings":"AAAA;;;6EAG6E;;AAE7E;EACE,aAAa;EACb,6BAA6B;EAC7B,6BAA6B;EAC7B,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,gCAAgC;EAChC,cAAc;EACd,4BAA4B;EAC5B,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,gCAAgC;EAChC,aAAa;EACb,gCAAgC;EAChC,gBAAgB;EAChB;;;0CAGwC;;AAE1C;;AAEA,8CAA8C;AAC9C;EACE,WAAW;EACX,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;;EAEE,2CAA2C;AAC7C;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;EACP,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,SAAS;EACT,aAAa;EACb,oBAAoB;EACpB,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,kCAAkC;EAClC,uCAAuC;EACvC,UAAU;EACV,oBAAoB;AACtB;;AAEA,qCAAqC;AACrC;;;EAGE,UAAU;EACV,oBAAoB;AACtB;;AAEA,oCAAoC;AACpC;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,aAAa;EACb,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,2CAA2C;AAC3C;EACE,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,sBAAsB;EACtB,+BAA+B;EAC/B,6BAA6B;EAC7B,qBAAqB;EACrB,4BAA4B;EAC5B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,4BAA4B;EAC5B,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,wDAAwD;AACxD;;EAEE,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,+CAA+C;AAC/C;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,wEAAwE;EACxE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,6BAA6B;EAC7B,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,6BAA6B;EAC7B,6BAA6B;EAC7B,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,8BAA8B;EAC9B,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE;0EACwE;EACxE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,yEAAyE;EACzE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,6BAA6B;EAC7B,2CAA2C;AAC7C;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;EAC3B,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,UAAU;AACV;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,4BAA4B;;AAE5B;;6EAE6E;;AAE7E;EACE,UAAU;EACV,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;AACf;;AAEA,UAAU;AACV;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,gCAAgC;EAChC,4BAA4B;EAC5B,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA,iCAAiC;AACjC,yBAAyB,aAAa,EAAE;AACxC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;AACjB;AACA,gCAAgC,+BAA+B,EAAE;;AAEjE;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,+BAA+B;EAC/B,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA,WAAW;AACX;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,WAAW;AACX;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,oCAAoC;EACpC,uDAAuD;EACvD,eAAe;EACf,mBAAmB;EACnB,uDAAuD;AACzD;;AAEA;EACE,sBAAsB;EACtB,4DAA4D;AAC9D;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,UAAU;EACV,WAAW;EACX,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,qCAAqC;EACrC,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,iCAAiC;EACjC,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,yDAAyD;EACzD,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,UAAU;AACZ;;AAEA,WAAW;AACX;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,0GAA0G;EAC1G,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,gBAAgB;AAClB;;AAEA;;6EAE6E;;AAE7E;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,UAAU;EACV,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB;;;qCAGmC;AACrC;;AAEA,uBAAuB;AACvB;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA,+DAA+D;AAC/D;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,qBAAqB;EACrB,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,wEAAwE;EACxE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,yCAAyC;EACzC,UAAU;EACV,8BAA8B;AAChC;;AAEA,wDAAwD;AACxD;;EAEE,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE;mEACiE;EACjE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,kCAAkC;AAClC;EACE,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,SAAO;EACP,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,iBAAiB;EACjB,SAAS;AACX;;AAEA;;;;iEAIiE;AACjE;EACE,0CAA0C;EAC1C,eAAe,SAAS,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;;EAEhE,iDAAiD;EACjD;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,6EAA6E;EAC/E;EACA,iDAAiD;EACjD,2BAA2B,aAAa,EAAE;;EAE1C,qCAAqC;EACrC;IACE,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,gCAAgC;IAChC,yCAAyC;IACzC,2BAA2B;IAC3B,eAAe;EACjB;EACA,0BAA0B,oBAAoB,EAAE;;EAEhD,8BAA8B;EAC9B,aAAa,uBAAuB,EAAE;EACtC,sBAAsB,eAAe,EAAE,iBAAiB,EAAE;EAC1D,wBAAwB;EACxB,oBAAoB,aAAa,EAAE;EACnC,iDAAiD,kBAAkB,EAAE;;EAErE,gCAAgC;EAChC,wBAAwB,qBAAqB,EAAE;EAC/C,4BAA4B,eAAe,EAAE;EAC7C,kBAAkB,kBAAkB,EAAE,mBAAmB,EAAE,QAAQ,EAAE;EACrE,cAAc,eAAe,EAAE,iBAAiB,EAAE,EAAE,uBAAuB;EAC3E,sBAAsB,QAAQ,EAAE;EAChC;8BAC4B,QAAQ,EAAE;EACtC,iBAAiB,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE;EACjE,qBAAqB,WAAW,EAAE,YAAY,EAAE;EAChD,yCAAyC;EACzC,oBAAoB,aAAa,EAAE;EACnC,qBAAqB,yBAAyB,EAAE,QAAQ,EAAE;EAC1D;IACE,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;EACA,oBAAoB,eAAe,EAAE,YAAY,EAAE,eAAe,EAAE;EACpE,oBAAoB,YAAY,EAAE,eAAe,EAAE;EACnD,wBAAwB;EACxB;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,4BAA4B;IAC5B,WAAW;EACb;EACA,qBAAqB,WAAW,EAAE,YAAY,EAAE;EAChD,uBAAuB,kCAAkC,EAAE,WAAW,EAAE;;EAExE,iBAAiB;EACjB,0BAA0B,cAAc,EAAE;;EAE1C,OAAO;EACP,qBAAqB,kBAAkB,EAAE;;EAEzC,qCAAqC;EACrC,sBAAsB,6BAA6B,EAAE;EACrD;IACE,cAAc;IACd,eAAe;IACf,wBAAwB;EAC1B;EACA,2BAA2B,qBAAqB,EAAE;EAClD,6BAA6B;EAC7B,iDAAiD,UAAU,EAAE;;EAE7D;gDAC8C;EAC9C,4BAA4B,YAAY,EAAE;EAC1C;IACE,UAAU;IACV,+BAA+B;IAC/B,8CAA8C;EAChD;AACF;;AAEA;;;iEAGiE;AACjE;;iEAEiE;AACjE;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,6BAA6B;EAC7B,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,sDAAsD;AACtD;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;;EAEA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,uCAAuC;EACvC,cAAc;AAChB;;AAEA,oEAAoE;AACpE;;;EAGE,aAAa;AACf;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,mBAAmB;EACnB,uCAAuC;EACvC,cAAc;EACd,WAAW;AACb;;AAEA;EACE,SAAO;EACP,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,oCAAoC;EACpC,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;EACnB,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,YAAY;EACZ,0BAA0B;EAC1B,sFAAgS;EAChS,gCAAgC;EAChC,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA,qBAAqB;AACrB;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,uCAAuC;AACvC;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,aAAa;EACb,iCAAiC;EACjC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,mBAAmB;EACnB,qCAAqC;EACrC,qBAAqB;EACrB,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,SAAS;EACT,qBAAqB;EACrB,0BAA0B;EAC1B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;iEAEiE;AACjE;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,6BAA6B;EAC7B,gCAAgC;EAChC,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;EAC3B,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,SAAS;EACT,0BAA0B;EAC1B,qBAAqB;EACrB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,8CAA8C;EAC9C,eAAe;EACf,wCAAgC;EAAhC,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,8CAA8C;EAC9C,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;;iEAEiE;AACjE;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;;EAEE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,kCAAkC;EAClC,kBAAkB;EAClB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,UAAU;EACV,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;iEAEiE;AACjE;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;;EAEE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,kCAAkC;EAClC,kBAAkB;EAClB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;EAC3B,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,aAAa;EACb,yCAAyC;EACzC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,aAAa;EACb,aAAa;EACb,yCAAyC;EACzC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;iEAEiE;AACjE;EACE,kBAAkB;EAClB,wBAAwB;EACxB,OAAO;EACP,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,4BAA4B;EAC5B,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,gFAAgF;EAChF,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,+BAA+B;EAC/B,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,oBAAoB;EACpB,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B","sourcesContent":["/* ========================================================================\n   LlmPractice — LLM 실습 - 기본 (Figma 68:1909)\n   헤더는 components/AppHeader (별도 CSS)\n   ======================================================================== */\n\n.llm {\n  height: 100vh;\n  background: var(--fg-bg-dark);\n  font-family: var(--font-sans);\n  color: var(--fg-text-basic);\n  display: flex;\n  flex-direction: column;\n}\n\n.llm__layout {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  background: var(--fg-bg-content);\n  margin: 0 16px;\n  border-radius: 16px 16px 0 0;\n  box-shadow: 0 0 6.3px 1px rgba(0, 0, 0, 0.26);\n  overflow: hidden;\n}\n\n/* ───────── 사이드바 ───────── */\n.llm__sidebar {\n  width: 272px;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 16px;\n  background: var(--fg-bg-content);\n  min-height: 0;\n  /* flex child가 콘텐츠 넘어 늘어나지 않도록 */\n  overflow: hidden;\n  transition:\n    width 0.28s cubic-bezier(0.4, 0, 0.2, 1),\n    padding 0.28s cubic-bezier(0.4, 0, 0.2, 1),\n    gap 0.28s cubic-bezier(0.4, 0, 0.2, 1);\n\n}\n\n/* 접힌 상태 — Figma sidebar-closed (2030:14844) */\n.llm__sidebar--collapsed {\n  width: 64px;\n  align-items: center;\n  gap: 24px;\n  padding: 30px 16px;\n}\n\n/* 자식 콘텐츠 등장 부드럽게 */\n.llm__sidebar>*,\n.llm__sidebar--collapsed>* {\n  animation: llmSidebarFadeIn 0.24s ease both;\n}\n\n@keyframes llmSidebarFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(2px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.llm__sidebar-mini-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  align-items: center;\n}\n\n.llm__sidebar-mini-btn {\n  width: 32px;\n  height: 32px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.llm__sidebar-mini-btn:hover {\n  background: rgba(0, 0, 0, 0.05);\n}\n\n.llm__sidebar-mini-btn:focus-visible {\n  outline: none;\n  background: rgba(0, 0, 0, 0.08);\n}\n\n.llm__sidebar-toggle {\n  width: 32px;\n  height: 32px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n}\n\n.llm__sidebar-toggle:hover {\n  background: rgba(0, 0, 0, 0.04);\n}\n\n.llm__sidebar-title {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 28px;\n  color: var(--fg-text-basic);\n}\n\n.llm__new-chat {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 10px;\n  background: var(--fg-bg-mychat);\n  border: 0;\n  border-radius: 12px;\n  font-family: inherit;\n  font-size: 15px;\n  font-weight: 500;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.llm__new-chat:hover {\n  background: #d8dbed;\n}\n\n.llm__sidebar-section {\n  margin-top: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  flex: 1;\n  min-height: 0;\n  /* flex child가 부모 안에서 줄어들 수 있게 (스크롤 동작 조건) */\n}\n\n.llm__sidebar-section-title {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n}\n\n/* ───────── 검색바 ───────── */\n.llm__search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 12px 7px 16px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 30px;\n}\n\n.llm__search-input {\n  flex: 1;\n  min-width: 0;\n  border: 0;\n  outline: none;\n  font-family: inherit;\n  font-size: 15px;\n  color: var(--fg-text-basic);\n  background: transparent;\n}\n\n.llm__search-input::placeholder {\n  color: var(--fg-text-gray);\n}\n\n.llm__search>svg {\n  flex-shrink: 0;\n  color: var(--fg-text-gray);\n}\n\n/* ───────── 대화 목록 ───────── */\n.llm__chat-list {\n  list-style: none;\n  margin: 0;\n  padding: 0 4px 0 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n}\n\n/* 사이드바 채팅 목록 스크롤바 (얇고 은은하게) */\n.llm__chat-list::-webkit-scrollbar {\n  width: 6px;\n}\n\n.llm__chat-list::-webkit-scrollbar-thumb {\n  background: rgba(0, 0, 0, 0.18);\n  border-radius: 3px;\n}\n\n.llm__chat-list::-webkit-scrollbar-thumb:hover {\n  background: rgba(0, 0, 0, 0.32);\n}\n\n.llm__chat-list::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.llm__chat-item {\n  position: relative;\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 10px;\n  background: #fff;\n  border: 1px solid #fff;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.llm__chat-item:hover {\n  background: #f9ffff;\n  border-color: var(--fg-emr-green);\n}\n\n.llm__chat-item--active {\n  background: var(--fg-bg-liteblue);\n  border-color: var(--fg-button-hover);\n}\n\n.llm__chat-item--accent-green {\n  background: #f9ffff;\n  border-color: var(--fg-emr-green);\n}\n\n.llm__chat-trash {\n  position: absolute;\n  right: 8px;\n  top: 8px;\n  flex-shrink: 0;\n  width: 28px;\n  height: 28px;\n  display: grid;\n  place-items: center;\n  background: #fff;\n  border: 0;\n  border-radius: 6px;\n  color: var(--fg-text-gray);\n  cursor: pointer;\n  transition: var(--transition-fast);\n  /* 기본은 숨김. 카드 hover 또는 active 일 때만 노출 */\n  opacity: 0;\n  pointer-events: none;\n}\n\n/* 카드 hover 또는 active 상태에서 삭제 버튼 노출 */\n.llm__chat-item:hover .llm__chat-trash,\n.llm__chat-item--active .llm__chat-trash,\n.llm__chat-item--accent-green .llm__chat-trash {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n/* 겹쳐 띄운 버튼이 제목을 가리도록 카드 상태별 배경 일치 */\n.llm__chat-item:hover .llm__chat-trash {\n  background: #f9ffff;\n}\n\n.llm__chat-item--active .llm__chat-trash {\n  background: var(--fg-bg-liteblue);\n}\n\n.llm__chat-item--accent-green .llm__chat-trash {\n  background: #f9ffff;\n}\n\n.llm__chat-item .llm__chat-trash:hover {\n  background: rgba(0, 0, 0, 0.06);\n  color: var(--fg-anti-red);\n}\n\n.llm__chat-icon {\n  flex-shrink: 0;\n  width: 28px;\n  height: 28px;\n  display: grid;\n  place-items: center;\n  color: var(--fg-text-purple);\n}\n\n.llm__chat-icon--agent {\n  color: var(--fg-button-hover);\n}\n\n.llm__chat-icon--chatbot {\n  color: var(--fg-emr-green);\n}\n\n.llm__chat-body {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding-top: 2px;\n}\n\n.llm__chat-agent {\n  margin: 0;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--fg-text-purple);\n}\n\n.llm__chat-title {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 500;\n  color: #464646;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.llm__chat-time {\n  margin: 0;\n  font-size: 13px;\n  color: var(--fg-text-gray);\n}\n\n.llm__chat-empty {\n  padding: 12px 10px;\n  font-size: 14px;\n  color: var(--fg-text-gray);\n  text-align: center;\n}\n\n/* ───────── 메인 영역 ───────── */\n.llm__main {\n  flex: 1;\n  min-width: 0;\n  background: #fff;\n  border-radius: 16px 16px 0 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 80px 24px 40px;\n  overflow-y: auto;\n}\n\n.llm__welcome {\n  width: 100%;\n  max-width: 760px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  text-align: left;\n  align-items: start;\n}\n\n.llm__welcome--center {\n  margin: 0 auto;\n  align-items: center;\n  text-align: center;\n  gap: 24px;\n  text-align: left;\n  align-items: start;\n}\n\n.llm__welcome-input {\n  width: 100%;\n}\n\n.llm__main--empty .llm-chat__scroller--welcome {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 24px;\n}\n\n.llm__welcome-title {\n  margin: 0;\n  font-size: 36px;\n  font-weight: 600;\n  line-height: 46px;\n  color: var(--fg-text-basic);\n}\n\n/* ───────── 채팅 입력박스 ───────── */\n.llm__input-box {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 20px;\n  background: #fff;\n  border-radius: 28px;\n  box-shadow: 0 2px 7px rgba(0, 0, 0, 0.2);\n}\n\n.llm__input {\n  width: 100%;\n  min-height: 26px;\n  max-height: 160px;\n  border: 0;\n  outline: none;\n  resize: none;\n  font-family: inherit;\n  font-size: 16px;\n  line-height: 26px;\n  color: var(--fg-text-basic);\n  background: transparent;\n  overflow-y: hidden;\n}\n\n.llm__input::placeholder {\n  color: var(--fg-text-gray);\n}\n\n.llm__input-actions {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.llm__input-actions-left {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.llm__input-actions-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* ───── 첨부 요약 pill (입력창 footer 왼쪽) ───── */\n.llm__attach-summary-wrap {\n  position: relative;\n  display: inline-flex;\n  min-width: 0;\n}\n\n.llm__attach-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 32px;\n  padding: 0 10px 0 10px;\n  background: var(--fg-bg-litepp);\n  border: 1px solid transparent;\n  border-radius: 9999px;\n  color: var(--fg-text-purple);\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.llm__attach-pill:hover {\n  background: var(--fg-bg-step-active);\n  border-color: var(--fg-button);\n}\n\n.llm__attach-pill--active {\n  background: #fff;\n  border-color: var(--fg-button);\n}\n\n.llm__attach-pill-text {\n  font-weight: 500;\n}\n\n.llm__attach-pill-count {\n  display: inline-grid;\n  place-items: center;\n  min-width: 18px;\n  height: 18px;\n  padding: 0 5px;\n  background: var(--fg-button);\n  border-radius: 9999px;\n  color: #fff;\n  font-size: 11px;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.llm__attach-pill-arrow {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 160ms ease;\n  color: var(--fg-text-purple);\n}\n\n.llm__attach-pill-arrow--up {\n  transform: rotate(180deg);\n}\n\n.llm__icon-btn {\n  width: 36px;\n  height: 36px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: 0;\n  border-radius: 18px;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.llm__icon-btn:hover {\n  background: var(--fg-bg-content);\n}\n\n.llm__icon-btn--active {\n  background: var(--fg-bg-content);\n}\n\n/* 웹 검색 토글 ON 상태 (Figma 59:1302 - Property 1=Variant3) */\n.llm__icon-btn.llm__icon-btn--on,\n.llm__icon-btn.llm__icon-btn--on:hover {\n  background: var(--fg-button-hover);\n  color: #fff;\n}\n\n.llm__icon-btn.llm__icon-btn--on:hover {\n  filter: brightness(1.06);\n}\n\n/* ───── 파일첨부 팝오버 메뉴 (Figma 2016:15065) ───── */\n.llm__attach-wrap {\n  position: relative;\n  display: inline-flex;\n}\n\n.attach-menu {\n  position: absolute;\n  bottom: calc(100% + 8px);\n  left: 0;\n  z-index: 80;\n  width: 226px;\n  padding: 20px;\n  background: #fff;\n  border-radius: 16px;\n  box-shadow: 0 8px 6px rgba(0, 0, 0, 0.07), 0 2px 4px rgba(0, 0, 0, 0.04);\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  font-family: var(--font-sans);\n  animation: attach-menu-fade 120ms ease-out;\n}\n\n.attach-menu--down {\n  bottom: auto;\n  top: calc(100% + 8px);\n}\n\n@keyframes attach-menu-fade {\n  from {\n    opacity: 0;\n    transform: translateY(4px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.attach-menu__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.attach-menu__item {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  width: 100%;\n  padding: 8px;\n  background: #fff;\n  border: 0;\n  border-radius: 8px;\n  font-family: inherit;\n  text-align: left;\n  cursor: pointer;\n  transition: background 120ms ease;\n}\n\n.attach-menu__item:hover {\n  background: var(--fg-bg-content);\n}\n\n.attach-menu__icon {\n  flex-shrink: 0;\n  width: 28px;\n  height: 28px;\n  display: grid;\n  place-items: center;\n  color: var(--fg-text-basic);\n}\n\n.attach-menu__text {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.attach-menu__title {\n  font-size: 15px;\n  font-weight: 500;\n  color: var(--fg-text-basic);\n  line-height: 1;\n}\n\n.attach-menu__desc {\n  font-size: 12px;\n  font-weight: 400;\n  color: var(--fg-text-gray);\n  line-height: 1;\n}\n\n/* 모델 선택 */\n.llm__model-select {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 8px 8px 16px;\n  background: var(--fg-bg-card);\n  border: 1px solid transparent;\n  border-radius: 30px;\n  font-family: inherit;\n  cursor: pointer;\n  transition: var(--transition-fast);\n  color: var(--fg-text-basic);\n}\n\n.llm__model-select:hover {\n  border-color: var(--fg-line);\n  background: #fff;\n}\n\n.llm__model-label {\n  font-size: 12px;\n  color: var(--fg-text-basic);\n}\n\n.llm__model-name {\n  font-size: 15px;\n  font-weight: 500;\n  color: var(--fg-text-basic);\n  white-space: nowrap;\n}\n\n.llm__model-badge {\n  display: inline-grid;\n  place-items: center;\n  min-width: 17px;\n  height: 17px;\n  padding: 0 4px;\n  background: var(--fg-anti-red);\n  border-radius: 9999px;\n  color: #fff;\n  font-size: 11px;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.llm__model-select--active {\n  border-color: var(--fg-line);\n  background: #fff;\n}\n\n.llm__model-arrow {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 160ms ease;\n}\n\n.llm__model-arrow--up {\n  transform: rotate(180deg);\n}\n\n/* ───── 모델 선택 모달 (popover) ───── */\n.llm__model-select-wrap {\n  position: relative;\n  display: inline-flex;\n}\n\n.model-picker {\n  /* Portal로 document.body 직속 렌더 + 인라인 style로 top/left/width/maxHeight 주입.\n     position/좌표/사이즈는 ModelPickerModal.js의 computePopoverPosition()가 결정. */\n  position: fixed;\n  z-index: 80;\n  overflow-y: auto;\n  padding: 20px;\n  background: var(--fg-bg-card);\n  border-radius: 16px;\n  box-shadow: 0 8px 12px rgba(0, 0, 0, 0.07), 0 2px 4px rgba(0, 0, 0, 0.04);\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  font-family: var(--font-sans);\n  animation: model-picker-fade 120ms ease-out;\n}\n\n@keyframes model-picker-fade {\n  from {\n    opacity: 0;\n    transform: translateY(4px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.model-picker__warning {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 400;\n  color: var(--fg-anti-red);\n}\n\n.model-picker__empty {\n  margin: 0;\n  padding: 16px 4px;\n  font-size: 13px;\n  font-weight: 400;\n  color: var(--fg-secondary, #6b7280);\n  text-align: center;\n}\n\n.model-picker__group {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.model-picker__group-head {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  height: 24px;\n}\n\n.model-picker__group-title {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 24px;\n  color: var(--fg-text-basic);\n}\n\n.model-picker__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 8px;\n}\n\n.model-picker__item {\n  min-width: 0;\n}\n\n.model-picker__row {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  width: 100%;\n  min-height: 32px;\n  padding: 6px 4px;\n  background: transparent;\n  border: 0;\n  border-radius: 6px;\n  font-family: inherit;\n  text-align: left;\n  cursor: pointer;\n  transition: background 120ms ease;\n}\n\n.model-picker__row:hover {\n  background: rgba(0, 0, 0, 0.04);\n}\n\n.model-picker__row--disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.model-picker__row--disabled:hover {\n  background: transparent;\n}\n\n.model-picker__check {\n  flex-shrink: 0;\n  align-self: flex-start;\n  margin-top: 2px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  border-radius: 4px;\n  background: #c2c2c2;\n  color: #fff;\n  transition: background 120ms ease;\n}\n\n.model-picker__check--on {\n  background: var(--fg-button);\n}\n\n.model-picker__name {\n  flex: 1 1 auto;\n  min-width: 0;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.35;\n  color: var(--fg-text-basic);\n  word-break: break-word;\n  overflow-wrap: anywhere;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.model-picker__type {\n  flex-shrink: 0;\n  align-self: flex-start;\n  margin-top: 2px;\n  font-size: 12px;\n  font-weight: 400;\n  color: var(--fg-text-gray);\n}\n\n/* 전송 버튼 */\n.llm__send-btn {\n  width: 36px;\n  height: 36px;\n  display: grid;\n  place-items: center;\n  padding: 0;\n  background: transparent;\n  border: 0;\n  cursor: pointer;\n  color: var(--fg-button);\n  transition: var(--transition-fast);\n}\n\n.llm__send-btn:hover {\n  color: var(--fg-button-hover);\n}\n\n/* ───────── 추천 카드 ───────── */\n.llm__suggestions {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n  width: 100%;\n}\n\n.llm__suggestion {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 4px;\n  padding: 12px 20px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n  text-align: left;\n  font-family: inherit;\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.llm__suggestion:hover {\n  background: var(--fg-bg-cooler);\n  border-color: var(--fg-button);\n}\n\n.llm__suggestion-body {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.llm__suggestion-title {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--fg-text-basic);\n  line-height: 1.4;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.llm__suggestion-summary {\n  margin: 0;\n  font-size: 14px;\n  color: var(--fg-text-gray);\n  line-height: 1.4;\n}\n\n.llm__suggestion-tag {\n  flex-shrink: 0;\n  padding: 4px;\n  background: var(--fg-bg-warning);\n  border-radius: 4px;\n  font-size: 12px;\n  color: var(--fg-anti-red);\n  white-space: nowrap;\n}\n\n/* ───────── 반응형 ───────── */\n\n/* ========================================================================\n   LlmChat — 대화 진행 화면 (Figma 68:3839)\n   ======================================================================== */\n\n.llm__main--chat {\n  padding: 0;\n  background: #fff;\n  border-radius: 16px 16px 0 0;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  overflow: hidden;\n  min-height: 0;\n}\n\n/* 상단 툴바 */\n.llm-chat__toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 16px;\n  background: var(--fg-bg-toolbar);\n  border-radius: 16px 16px 0 0;\n  border-bottom: 1px solid var(--fg-line);\n  flex-shrink: 0;\n}\n\n.llm-chat__toolbar-left {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.llm-chat__toolbar-back {\n  width: 32px;\n  height: 32px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  color: var(--fg-text-menu);\n  cursor: pointer;\n}\n\n.llm-chat__toolbar-back:hover {\n  background: rgba(0, 0, 0, 0.04);\n}\n\n/* 대화목록 열기 버튼 — 모바일 전용(데스크탑 숨김) */\n.llm-chat__mobile-menu { display: none; }\n.llm-chat__toolbar-menu {\n  display: none;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  color: var(--fg-text-menu);\n  cursor: pointer;\n}\n.llm-chat__toolbar-menu:hover { background: rgba(0, 0, 0, 0.04); }\n\n.llm-chat__toolbar-title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n  line-height: 26px;\n}\n\n.llm-chat__toolbar-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.llm-chat__toolbar-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 5px 7px 7px;\n  background: var(--fg-bg-litepp);\n  border: 0;\n  border-radius: 4px;\n  color: var(--fg-button-hover);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.llm-chat__toolbar-btn:hover {\n  background: #d8dbed;\n}\n\n.llm-chat__toolbar-model-dot {\n  width: 14px;\n  height: 14px;\n  border-radius: 9999px;\n  background: var(--gpt-color, #10a37f);\n}\n\n/* 스크롤 영역 */\n.llm-chat__scroller {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 40px 24px 200px;\n}\n\n.llm-chat__messages {\n  max-width: 760px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 40px;\n}\n\n/* 메시지 공통 */\n.llm-chat__msg {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.llm-chat__msg--user {\n  align-items: flex-end;\n}\n\n.llm-chat__msg--assistant {\n  align-items: flex-start;\n}\n\n.llm-chat__bubble {\n  max-width: 700px;\n  padding: 12px 16px;\n  font-size: 16px;\n  line-height: 26px;\n  color: var(--fg-text-basic);\n}\n\n.llm-chat__bubble--user {\n  background: var(--fg-bg-mychat);\n  border-radius: 16px 16px 0 16px;\n}\n\n.llm-chat__bubble p {\n  margin: 0;\n  white-space: pre-wrap;\n}\n\n/* 어시스턴트 마크다운 */\n.llm-chat__markdown {\n  width: 100%;\n  font-size: 16px;\n  line-height: 26px;\n  color: var(--fg-text-basic);\n}\n\n/* 어시스턴트 메시지에 첨부되는 생성 이미지 */\n.llm-chat__images {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 12px;\n  width: 100%;\n}\n\n.llm-chat__image {\n  max-width: 100%;\n  max-height: 400px;\n  border-radius: var(--radius-md, 8px);\n  border: 1px solid var(--fg-border, rgba(0, 0, 0, 0.08));\n  cursor: pointer;\n  object-fit: contain;\n  transition: transform 120ms ease, box-shadow 120ms ease;\n}\n\n.llm-chat__image:hover {\n  transform: scale(1.02);\n  box-shadow: var(--shadow-md, 0 4px 12px rgba(0, 0, 0, 0.08));\n}\n\n.llm-chat__markdown h1 {\n  font-size: 36px;\n  font-weight: 600;\n  line-height: 46px;\n  margin: 0 0 20px;\n}\n\n.llm-chat__markdown h2 {\n  font-size: 36px;\n  font-weight: 600;\n  line-height: 46px;\n  margin: 24px 0 16px;\n}\n\n.llm-chat__markdown h3 {\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 28px;\n  margin: 20px 0 12px;\n}\n\n.llm-chat__markdown h4 {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 26px;\n  margin: 16px 0 8px;\n}\n\n.llm-chat__markdown p {\n  margin: 0 0 16px;\n}\n\n.llm-chat__markdown ul,\n.llm-chat__markdown ol {\n  padding-left: 12px;\n  margin: 0 0 16px;\n}\n\n.llm-chat__markdown li {\n  margin: 0 0 10px;\n  padding-left: 8px;\n  list-style: none;\n  position: relative;\n}\n\n.llm-chat__markdown li::before {\n  content: '';\n  position: absolute;\n  left: -4px;\n  top: 11px;\n  width: 4px;\n  height: 4px;\n  background: var(--fg-text-basic);\n  border-radius: 9999px;\n}\n\n.llm-chat__markdown table {\n  border-collapse: collapse;\n  border: 1px solid var(--fg-line);\n  width: 100%;\n  margin: 0 0 16px;\n}\n\n.llm-chat__markdown th,\n.llm-chat__markdown td {\n  padding: 8px;\n  border-left: 1px solid var(--fg-line);\n  border-top: 1px solid var(--fg-line);\n  text-align: left;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 26px;\n}\n\n.llm-chat__markdown th {\n  background: rgba(0, 0, 0, 0.06);\n}\n\n.llm-chat__markdown blockquote {\n  margin: 0 0 16px;\n  padding: 12px 12px 12px 20px;\n  background: var(--fg-bg-liteblue);\n  border-left: 3px solid var(--fg-blue-lite);\n  border-radius: 12px;\n}\n\n.llm-chat__markdown blockquote p {\n  margin: 0;\n}\n\n.llm-chat__markdown a {\n  color: var(--fg-link);\n  text-decoration: underline;\n}\n\n.llm-chat__markdown a:hover {\n  color: var(--fg-link-hover);\n}\n\n.llm-chat__markdown hr {\n  border: 0;\n  border-top: 1px solid var(--fg-line);\n  margin: 24px 0;\n}\n\n.llm-chat__markdown code {\n  font-family: ui-monospace, 'SF Mono', Consolas, monospace;\n  font-size: 14px;\n  padding: 2px 4px;\n  background: rgba(0, 0, 0, 0.04);\n  border-radius: 4px;\n}\n\n.llm-chat__markdown pre {\n  background: #f6f8ff;\n  border: 1px solid var(--fg-line);\n  border-radius: 8px;\n  padding: 12px 16px;\n  overflow-x: auto;\n  margin: 0 0 16px;\n}\n\n.llm-chat__markdown pre code {\n  background: transparent;\n  padding: 0;\n}\n\n/* 메시지 액션 */\n.llm-chat__msg-actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  align-self: flex-end;\n}\n\n.llm-chat__msg-action {\n  width: 32px;\n  height: 32px;\n  display: grid;\n  place-items: center;\n  padding: 2px;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.llm-chat__msg-action:hover {\n  background: rgba(0, 0, 0, 0.04);\n}\n\n.llm-chat__msg-time {\n  font-size: 12px;\n  color: var(--fg-text-gray);\n  margin-left: 4px;\n}\n\n/* 입력박스 영역 (스크롤 위에 sticky bottom) */\n.llm-chat__input-area {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n  padding: 40px 16px 20px;\n  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.7) 30%, #fff 100%);\n  pointer-events: none;\n}\n\n.llm-chat__input-area>* {\n  pointer-events: auto;\n  width: 100%;\n  max-width: 760px;\n}\n\n/* ========================================================================\n   LlmChatMulti — 다중 모델 비교 (Figma 82:5718)\n   ======================================================================== */\n\n.llm__main--multi {\n  padding: 0;\n}\n\n.llm-multi__toolbar-model {\n  width: 32px;\n  padding: 0;\n  display: grid;\n  place-items: center;\n}\n\n.llm-multi__toolbar-model {\n  border-radius: 8px;\n  transition:\n    opacity var(--transition-fast),\n    background var(--transition-fast),\n    box-shadow var(--transition-fast);\n}\n\n/* 3컬럼 가로 분할 + 가로 스크롤 */\n.llm-multi__columns {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  overflow-x: auto;\n  overflow-y: hidden;\n}\n\n.llm-multi__col-wrapper {\n  flex: 1 1 0;\n  min-width: 480px;\n  display: flex;\n  flex-direction: column;\n  border-right: 1px solid var(--fg-line);\n}\n\n.llm-multi__col-wrapper:last-child {\n  border-right: 0;\n}\n\n.llm-multi__col-scroller {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0 30px 200px;\n  position: relative;\n}\n\n.llm-multi__column {\n  display: flex;\n  flex-direction: column;\n  padding-top: 0;\n}\n\n/* sticky 모델 칩 — col-body 위에 겹쳐 떠있고, 메시지가 그 뒤로 통과(그라디언트로 페이드) */\n.llm-multi__col-head {\n  position: sticky;\n  top: 0;\n  z-index: 4;\n  margin: 0 -30px -82px;\n  padding: 20px 30px 30px;\n  display: flex;\n  justify-content: center;\n  background: linear-gradient(to top, rgba(255, 255, 255, 0) 0%, #fff 70%);\n  pointer-events: none;\n}\n\n.llm-multi__model-chip {\n  pointer-events: auto;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 5px 6px;\n  background: var(--fg-text-basic);\n  border-radius: 30px;\n  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.29);\n  opacity: 0;\n  transition: opacity 0.18s ease;\n}\n\n/* 컬럼 호버/포커스 시에만 모델 칩 노출 (에이전트 채팅 floating-toolbar 패턴) */\n.llm-multi__col-wrapper:hover .llm-multi__model-chip,\n.llm-multi__col-wrapper:focus-within .llm-multi__model-chip {\n  opacity: 1;\n}\n\n.llm-multi__model-chip-info {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 0 5px;\n}\n\n.llm-multi__model-chip-name {\n  font-size: 12px;\n  font-weight: 600;\n  color: #fff;\n  white-space: nowrap;\n}\n\n.llm-multi__model-chip-close {\n  display: inline-grid;\n  place-items: center;\n  width: 32px;\n  height: 32px;\n  padding: 0 6px;\n  background: transparent;\n  border: 0;\n  border-radius: 30px;\n  color: rgba(255, 255, 255, 0.6);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.llm-multi__model-chip-close:hover {\n  color: #fff;\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.llm-multi__col-body {\n  /* 모델 칩이 호버 시에만 floating overlay 로 노출되므로 첫 메시지를 윗단으로 끌어올림.\n     호버 시 칩은 col-head 의 sticky + linear-gradient 페이드로 메시지 위에 겹친다. */\n  padding-top: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 40px;\n}\n\n/* multi 컬럼 내 메시지는 한 컬럼 폭 내에서 좁게 */\n.llm-multi__column .llm-chat__bubble--user {\n  max-width: 100%;\n}\n\n.llm-multi__column .llm-chat__markdown h1,\n.llm-multi__column .llm-chat__markdown h2 {\n  font-size: 28px;\n  line-height: 38px;\n}\n\n@media (max-width: 1280px) {\n  .llm-multi__col-wrapper {\n    min-width: 380px;\n  }\n}\n\n/* 멀티 컬럼: 메시지 없을 때 placeholder */\n.llm-multi__col-empty {\n  display: flex;\n  flex: 1;\n  align-items: center;\n  justify-content: center;\n  min-height: 240px;\n  padding: 32px 16px;\n}\n\n.llm-multi__col-empty-text {\n  text-align: center;\n  color: var(--text-secondary, #9ca3af);\n  font-size: 14px;\n  line-height: 22px;\n  margin: 0;\n}\n\n/* ════════════════════════════════════════════════════════════\n   모바일 (≤768px) — 단일 모델 채팅으로 좁힘\n   · 사이드바: 기본 접힘(레일), 펼치면 오버레이 드로어\n   · 멀티 컬럼(레거시 세션): 한 모델씩 가로 스냅 스와이프\n   ════════════════════════════════════════════════════════════ */\n@media (max-width: 768px) {\n  /* 카드 셸 좌우 여백 제거 — 채팅 본문 풀폭 + 플로팅 버튼 기준점 */\n  .llm__layout { margin: 0; border-radius: 0; position: relative; }\n\n  /* 펼친 사이드바 = 화면 위로 덮는 드로어 (+ 큰 spread 그림자로 스크림) */\n  .llm__sidebar {\n    position: fixed;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    width: 84vw;\n    max-width: 320px;\n    z-index: 200;\n    border-radius: 0;\n    box-shadow: 0 0 0 100vw rgba(14, 27, 43, 0.4), 8px 0 24px rgba(0, 0, 0, 0.18);\n  }\n  /* 접힘 = 레일 숨김(프롬프트처럼 풀폭). 대화목록은 버튼으로 여는 드로어로 접근 */\n  .llm__sidebar--collapsed { display: none; }\n\n  /* 대화목록 열기 버튼 노출 — 웰컴(플로팅) / 채팅(툴바) */\n  .llm-chat__mobile-menu {\n    position: absolute;\n    top: 10px;\n    left: 10px;\n    z-index: 60;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 40px;\n    height: 40px;\n    border-radius: 12px;\n    background: #fff;\n    border: 1px solid var(--fg-line);\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);\n    color: var(--fg-text-basic);\n    cursor: pointer;\n  }\n  .llm-chat__toolbar-menu { display: inline-flex; }\n\n  /* 메인 · 웰컴 — 좌우 패딩 최소화(폭 확보) */\n  .llm__main { padding: 20px 10px 28px; }\n  .llm__welcome-title { font-size: 23px; line-height: 31px; }\n  /* 모바일 — 예시(추천) 메시지 숨김 */\n  .llm__suggestions { display: none; }\n  .llm__main--empty .llm-chat__scroller--welcome { padding: 24px 10px; }\n\n  /* 입력창 — 화면 가득 + 컴팩트(폰트·버튼 축소) */\n  .llm-chat__input-area { padding: 14px 8px 8px; }\n  .llm-chat__input-area > * { max-width: 100%; }\n  .llm__input-box { padding: 10px 12px; border-radius: 18px; gap: 8px; }\n  .llm__input { font-size: 16px; line-height: 22px; } /* 16px: iOS 포커스 줌 방지 */\n  .llm__input-actions { gap: 4px; }\n  .llm__input-actions-left,\n  .llm__input-actions-right { gap: 4px; }\n  .llm__icon-btn { width: 30px; height: 30px; border-radius: 15px; }\n  .llm__icon-btn svg { width: 18px; height: 18px; }\n  /* 'LLM 모델' 캡션 숨김 + 모델 셀렉트 축소 + 모델명 말줄임 */\n  .llm__model-label { display: none; }\n  .llm__model-select { padding: 5px 7px 5px 10px; gap: 4px; }\n  .llm__model-name {\n    font-size: 13px;\n    max-width: 88px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n  .llm__model-badge { min-width: 15px; height: 15px; font-size: 10px; }\n  .llm__attach-pill { height: 28px; font-size: 12px; }\n  /* 전송 = 채워진 원형 버튼(컴팩트) */\n  .llm__send-btn {\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    background: var(--fg-button);\n    color: #fff;\n  }\n  .llm__send-btn svg { width: 18px; height: 18px; }\n  .llm__send-btn:hover { background: var(--fg-button-hover); color: #fff; }\n\n  /* 사용자 말풍선 폭 확대 */\n  .llm-chat__bubble--user { max-width: 90%; }\n\n  /* 툴바 */\n  .llm-chat__toolbar { padding: 10px 12px; }\n\n  /* 멀티 컬럼(레거시 세션) — 한 모델씩 가로 스냅 스와이프 */\n  .llm-multi__columns { scroll-snap-type: x mandatory; }\n  .llm-multi__col-wrapper {\n    flex: 0 0 100%;\n    min-width: 100%;\n    scroll-snap-align: start;\n  }\n  .llm-multi__col-scroller { padding: 0 16px 180px; }\n  /* 모바일엔 호버가 없으므로 모델 칩 상시 노출 */\n  .llm-multi__col-wrapper .llm-multi__model-chip { opacity: 1; }\n\n  /* 모바일 멀티 모드 — 헤더 프로바이더 아이콘이 컬럼 전환 탭으로 동작.\n     한 번에 한 컬럼만 보이므로 비활성은 흐리게, 보이는 모델만 또렷하게 강조 */\n  .llm-multi__toolbar-model { opacity: 0.4; }\n  .llm-multi__toolbar-model--active {\n    opacity: 1;\n    background: var(--fg-bg-litepp);\n    box-shadow: inset 0 0 0 1.5px var(--fg-button);\n  }\n}\n\n/* ============================================================\n *  파일첨부 모달 (템플릿 / 지식베이스 / 프로젝트 공통 셸)\n *  - 신규 디자인 토큰(fg-*) 기반, 라이트 테마\n * ============================================================ */\n/* ============================================================\n *  Attach Modal — LLM 실습 + 메뉴 모달 공통 셸 (Figma 2047:12809)\n * ============================================================ */\n.attach-modal__overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 200;\n  background: rgba(15, 17, 28, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  animation: attach-modal-fade-in 140ms ease-out;\n}\n\n@keyframes attach-modal-fade-in {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n.attach-modal {\n  width: 100%;\n  max-width: 640px;\n  max-height: min(90vh, 800px);\n  background: #ffffff;\n  border-radius: 16px;\n  box-shadow: 0 4px 7px rgba(0, 0, 0, 0.2);\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  overflow: hidden;\n  font-family: var(--font-sans);\n  animation: attach-modal-pop 160ms ease-out;\n}\n\n.attach-modal--template {\n  max-width: min(1336px, calc(100vw - 40px));\n}\n\n/* 검색 리스트형 첨부 모달 — 검색 결과 수에 따라 높이가 출렁이지 않게 최대 높이로 고정 */\n.attach-modal--fixed-height {\n  height: min(90vh, 800px);\n}\n\n.attach-modal--settings {\n  max-width: 560px;\n}\n\n@keyframes attach-modal-pop {\n  from {\n    opacity: 0;\n    transform: translateY(8px) scale(0.985);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n/* ───── header ───── */\n.attach-modal__header {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--fg-line);\n  flex-shrink: 0;\n}\n\n/* figma 시안에서 헤더의 컬러 카테고리 아이콘은 제거됨 — 기존 마크업 호환을 위해 클래스는 보존하되 숨김 처리 */\n.attach-modal__header-icon,\n.attach-modal__header-icon--purple,\n.attach-modal__header-icon--green {\n  display: none;\n}\n\n.attach-modal__header-text {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.attach-modal__title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 28px;\n  color: var(--fg-text-basic);\n}\n\n.attach-modal__subtitle {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 400;\n  color: var(--fg-text-basic);\n  line-height: 1.4;\n}\n\n.attach-modal__close {\n  flex-shrink: 0;\n  width: 32px;\n  height: 32px;\n  display: grid;\n  place-items: center;\n  padding: 2px;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.attach-modal__close:hover {\n  background: var(--fg-bg-content);\n}\n\n/* ───── tabs (template only) — Figma 2047:12880 ───── */\n.attach-modal__tabs {\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid var(--fg-line);\n  flex-shrink: 0;\n  width: 100%;\n}\n\n.attach-modal__tab {\n  flex: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  padding: 10px;\n  background: transparent;\n  border: 0;\n  border-bottom: 3px solid transparent;\n  font-family: inherit;\n  font-size: 15px;\n  font-weight: 500;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n  transition: border-color 120ms ease;\n  margin-bottom: -1px;\n}\n\n.attach-modal__tab:hover:not(.attach-modal__tab--active) {\n  border-bottom-color: var(--fg-line);\n}\n\n.attach-modal__tab--active {\n  border-bottom-color: var(--fg-text-basic);\n}\n\n.attach-modal__tab-count {\n  display: inline-flex;\n  align-items: center;\n  font-size: 13px;\n  font-weight: 400;\n  color: var(--fg-text-gray);\n  line-height: 1;\n}\n\n/* ───── toolbar (search + sort) ───── */\n.attach-modal__toolbar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.attach-modal__search {\n  flex: 1;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 12px 7px 20px;\n  background: #ffffff;\n  border: 1px solid var(--fg-line);\n  border-radius: 30px;\n  color: var(--fg-text-gray);\n  transition: var(--transition-fast);\n}\n\n.attach-modal__search:focus-within {\n  border-color: var(--fg-text-basic);\n}\n\n.attach-modal__search input {\n  flex: 1;\n  min-width: 0;\n  border: 0;\n  outline: 0;\n  background: transparent;\n  font-family: inherit;\n  font-size: 16px;\n  line-height: 26px;\n  color: var(--fg-text-basic);\n}\n\n.attach-modal__search input::placeholder {\n  color: var(--fg-text-gray);\n}\n\n.attach-modal__sort {\n  position: relative;\n  flex-shrink: 0;\n}\n\n.attach-modal__sort select {\n  appearance: none;\n  -webkit-appearance: none;\n  width: 122px;\n  padding: 8px 32px 8px 16px;\n  background: #ffffff url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12' fill='none' stroke='%233b3b3b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><path d='M3 5 L6 8 L9 5'/></svg>\") no-repeat right 8px center;\n  border: 1px solid var(--fg-line);\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 16px;\n  line-height: 26px;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.attach-modal__sort select:hover {\n  border-color: var(--fg-text-basic);\n}\n\n/* ───── body ───── */\n.attach-modal__body {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.attach-modal__empty {\n  padding: 40px 12px;\n  text-align: center;\n  font-size: 14px;\n  color: var(--fg-text-gray);\n  list-style: none;\n}\n\n/* ───── upload / selected tags ───── */\n.attach-modal__upload {\n  flex-shrink: 0;\n}\n\n.attach-modal__tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  padding: 12px;\n  background: var(--fg-bg-liteblue);\n  border-radius: 12px;\n  flex-shrink: 0;\n}\n\n.attach-modal__tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 6px 4px 10px;\n  background: #ffffff;\n  border: 1px solid var(--fg-bg-litepp);\n  border-radius: 9999px;\n  font-size: 12px;\n  color: var(--fg-text-basic);\n  max-width: 240px;\n}\n\n.attach-modal__tag> :not(button) {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.attach-modal__tag-remove {\n  display: inline-grid;\n  place-items: center;\n  width: 18px;\n  height: 18px;\n  background: transparent;\n  border: 0;\n  border-radius: 9999px;\n  color: var(--fg-text-gray);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.attach-modal__tag-remove:hover {\n  background: var(--fg-bg-content);\n  color: var(--fg-anti-red);\n}\n\n/* ───── footer ───── */\n.attach-modal__footer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding-top: 12px;\n  flex-shrink: 0;\n}\n\n.attach-modal__btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 42px;\n  padding: 6px 12px;\n  background: var(--fg-text-gray);\n  border: 0;\n  border-radius: 12px;\n  font-family: inherit;\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 1;\n  color: #ffffff;\n  cursor: pointer;\n  transition: background 120ms ease, transform 120ms ease;\n}\n\n.attach-modal__btn svg {\n  display: block;\n}\n\n.attach-modal__btn:hover:not(:disabled) {\n  background: #6f6f6f;\n}\n\n.attach-modal__btn--primary {\n  background: var(--fg-button);\n}\n\n.attach-modal__btn--primary:hover:not(:disabled) {\n  background: var(--fg-button-hover);\n}\n\n.attach-modal__btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.attach-modal__footer--split {\n  justify-content: space-between;\n}\n\n.attach-modal__footer-right {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* ============================================================\n *  상세 설정 (튜닝) 모달 — 프리셋 + 슬라이더 (Figma 2047:12831 / 2047:12836)\n * ============================================================ */\n.tuning-section {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.tuning-section__title {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--fg-text-basic);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.tuning-section__hint {\n  margin: 0;\n  font-size: 14px;\n  color: var(--fg-text-gray);\n  line-height: 1.4;\n}\n\n.tuning-section__hint b {\n  color: var(--fg-text-basic);\n  font-weight: 600;\n}\n\n.tuning-presets {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.tuning-preset {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  padding: 16px;\n  background: var(--fg-bg-card);\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n  font-family: inherit;\n  text-align: center;\n  cursor: pointer;\n  transition: border-color 120ms ease, background 120ms ease, color 120ms ease;\n}\n\n.tuning-preset:hover {\n  background: var(--fg-bg-card);\n  border-color: var(--fg-text-basic);\n}\n\n.tuning-preset--active {\n  background: #ffffff;\n  border-color: var(--fg-text-basic);\n}\n\n.tuning-preset__name {\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 26px;\n  color: var(--fg-text-gray);\n}\n\n.tuning-preset:hover .tuning-preset__name,\n.tuning-preset--active .tuning-preset__name {\n  color: var(--fg-text-basic);\n}\n\n.tuning-preset__value {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  color: var(--fg-text-gray);\n}\n\n.tuning-slider {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.tuning-slider__header {\n  display: grid;\n  grid-template-columns: 160px 1fr 60px;\n  gap: 20px;\n  align-items: center;\n}\n\n.tuning-slider__label {\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 28px;\n  color: var(--fg-text-basic);\n}\n\n.tuning-slider__value {\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 28px;\n  color: var(--fg-text-basic);\n  text-align: right;\n  font-variant-numeric: tabular-nums;\n}\n\n.tuning-slider__input {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 100%;\n  height: 4px;\n  margin: 0;\n  background: var(--fg-line);\n  border-radius: 9999px;\n  outline: none;\n  cursor: pointer;\n}\n\n.tuning-slider__input::-webkit-slider-runnable-track {\n  height: 4px;\n  border-radius: 9999px;\n  background: transparent;\n}\n\n.tuning-slider__input::-moz-range-track {\n  height: 4px;\n  border-radius: 9999px;\n  background: var(--fg-line);\n}\n\n.tuning-slider__input::-moz-range-progress {\n  height: 4px;\n  border-radius: 9999px;\n  background: var(--fg-bg-litepp-hover);\n}\n\n.tuning-slider__input::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 24px;\n  height: 24px;\n  margin-top: -10px;\n  background: var(--fg-button);\n  border: 3px solid #ffffff;\n  border-radius: 50%;\n  box-shadow: 0 2px 6px rgba(115, 98, 194, 0.35);\n  cursor: pointer;\n  transition: transform 120ms ease;\n}\n\n.tuning-slider__input::-webkit-slider-thumb:hover {\n  transform: scale(1.08);\n}\n\n.tuning-slider__input::-moz-range-thumb {\n  width: 24px;\n  height: 24px;\n  background: var(--fg-button);\n  border: 3px solid #ffffff;\n  border-radius: 50%;\n  box-shadow: 0 2px 6px rgba(115, 98, 194, 0.35);\n  cursor: pointer;\n}\n\n.tuning-slider__desc {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 400;\n  color: var(--fg-text-gray);\n  line-height: 1.4;\n}\n\n/* ============================================================\n *  list 스타일 (지식베이스 / 프로젝트) — Figma 2047:12820 / 2047:12827\n * ============================================================ */\n.attach-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.attach-list__item {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  width: 100%;\n  padding: 16px 20px;\n  background: #ffffff;\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n  font-family: inherit;\n  text-align: left;\n  cursor: pointer;\n  transition: border-color 120ms ease, background 120ms ease;\n}\n\n.attach-list__item:hover:not(:disabled),\n.attach-list__item--selected {\n  border-color: var(--fg-text-basic);\n  background: #ffffff;\n}\n\n.attach-list__item--disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.attach-list__check {\n  flex-shrink: 0;\n  display: inline-grid;\n  place-items: center;\n  width: 16px;\n  height: 16px;\n  margin-top: 6px;\n  background: #ffffff;\n  border: 1.5px solid var(--fg-line);\n  border-radius: 4px;\n  color: #ffffff;\n  transition: var(--transition-fast);\n}\n\n.attach-list__check--on {\n  background: var(--fg-side-hover);\n  border-color: var(--fg-side-hover);\n}\n\n.attach-list__icon {\n  flex-shrink: 0;\n  width: 36px;\n  height: 36px;\n  display: grid;\n  place-items: center;\n  border-radius: 8px;\n  background: var(--fg-bg-content);\n  color: var(--fg-text-basic);\n}\n\n.attach-list__icon--green {\n  background: var(--fg-bg-tag-lime);\n  color: var(--fg-class-green);\n}\n\n.attach-list__color {\n  flex-shrink: 0;\n  width: 4px;\n  align-self: stretch;\n  border-radius: 4px;\n  background: var(--fg-button);\n}\n\n.attach-list__info {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.attach-list__name {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 28px;\n  color: var(--fg-text-basic);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.attach-list__meta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 4px;\n  font-size: 13px;\n  font-weight: 400;\n  color: var(--fg-text-gray);\n  line-height: 1.2;\n}\n\n.attach-list__meta-divider {\n  display: inline-block;\n  width: 1px;\n  height: 14px;\n  background: var(--fg-line);\n  margin: 0 4px;\n}\n\n.attach-list__badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 1px 6px;\n  background: var(--fg-bg-content);\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--fg-text-gray);\n}\n\n/* ============================================================\n *  Template grid 스타일 (Figma 2047:12874)\n * ============================================================ */\n.attach-template__hint {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 400;\n  color: var(--fg-text-basic);\n  line-height: 1.4;\n}\n\n.attach-template__grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.attach-template__card {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 16px 20px;\n  background: #ffffff;\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n  font-family: inherit;\n  text-align: left;\n  cursor: pointer;\n  transition: border-color 120ms ease, background 120ms ease;\n}\n\n.attach-template__card:hover,\n.attach-template__card--selected {\n  border-color: var(--fg-text-basic);\n  background: #ffffff;\n}\n\n.attach-template__check {\n  flex-shrink: 0;\n  display: inline-grid;\n  place-items: center;\n  width: 16px;\n  height: 16px;\n  margin-top: 6px;\n  background: #ffffff;\n  border: 1.5px solid var(--fg-line);\n  border-radius: 4px;\n  color: #ffffff;\n  transition: var(--transition-fast);\n}\n\n.attach-template__check--on {\n  background: var(--fg-side-hover);\n  border-color: var(--fg-side-hover);\n}\n\n.attach-template__card-body {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.attach-template__card-head {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  width: 100%;\n}\n\n.attach-template__card-name {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 28px;\n  color: var(--fg-text-basic);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.attach-template__card-meta {\n  font-size: 13px;\n  font-weight: 400;\n  color: var(--fg-text-gray);\n  line-height: 1.2;\n}\n\n.attach-template__card-content {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  width: 100%;\n}\n\n.attach-template__card-desc {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 24px;\n  color: var(--fg-text-basic);\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.attach-template__preview {\n  margin: 0;\n  height: 160px;\n  padding: 12px;\n  background: var(--fg-bg-stepper-inactive);\n  border-radius: 8px;\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 24px;\n  color: var(--fg-text-gray);\n  overflow-x: clip;\n  overflow-y: auto;\n  word-break: break-word;\n}\n\n/* fewshot 카드 */\n.attach-template__fewshot {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  width: 100%;\n}\n\n.attach-template__fewshot-row {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  width: 100%;\n}\n\n.attach-template__fewshot-label {\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 24px;\n  color: var(--fg-text-basic);\n}\n\n.attach-template__fewshot-text {\n  margin: 0;\n  height: 140px;\n  padding: 12px;\n  background: var(--fg-bg-stepper-inactive);\n  border-radius: 8px;\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 24px;\n  color: var(--fg-text-gray);\n  overflow-x: clip;\n  overflow-y: auto;\n  word-break: break-word;\n}\n\n/* ============================================================\n *  첨부 요약 드롭다운 (입력창 내부 pill 클릭 시)\n * ============================================================ */\n.attachment-summary {\n  position: absolute;\n  bottom: calc(100% + 8px);\n  left: 0;\n  z-index: 80;\n  width: 360px;\n  max-width: calc(100vw - 48px);\n  max-height: min(60vh, 460px);\n  padding: 8px;\n  background: #fff;\n  border-radius: 16px;\n  box-shadow: 0 12px 24px rgba(15, 17, 28, 0.12), 0 2px 4px rgba(15, 17, 28, 0.06);\n  display: flex;\n  flex-direction: column;\n  font-family: var(--font-sans);\n  animation: attach-menu-fade 120ms ease-out;\n  overflow: hidden;\n}\n\n.attachment-summary--down {\n  bottom: auto;\n  top: calc(100% + 8px);\n}\n\n.attachment-summary__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 10px 12px;\n  border-bottom: 1px solid var(--fg-line);\n}\n\n.attachment-summary__head-title {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n}\n\n.attachment-summary__head-count {\n  display: inline-grid;\n  place-items: center;\n  min-width: 18px;\n  height: 18px;\n  padding: 0 6px;\n  background: var(--fg-bg-litepp);\n  border-radius: 9999px;\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--fg-text-purple);\n  line-height: 1;\n}\n\n.attachment-summary__clear {\n  background: transparent;\n  border: 0;\n  font-family: inherit;\n  font-size: 12px;\n  color: var(--fg-text-gray);\n  cursor: pointer;\n  padding: 4px 6px;\n  border-radius: 6px;\n  transition: var(--transition-fast);\n}\n\n.attachment-summary__clear:hover {\n  background: var(--fg-bg-content);\n  color: var(--fg-anti-red);\n}\n\n.attachment-summary__list {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 8px 4px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.attachment-summary__section-title {\n  padding: 6px 8px 4px;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--fg-text-gray);\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.attachment-summary__item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 8px;\n  border-radius: 8px;\n  transition: background 120ms ease;\n}\n\n.attachment-summary__item:hover {\n  background: var(--fg-bg-content);\n}\n\n.attachment-summary__icon {\n  flex-shrink: 0;\n  width: 28px;\n  height: 28px;\n  display: grid;\n  place-items: center;\n  border-radius: 6px;\n  background: var(--fg-bg-litepp);\n  color: var(--fg-text-purple);\n}\n\n.attachment-summary__item--knowledge .attachment-summary__icon {\n  background: var(--fg-bg-tag-lime);\n  color: var(--fg-class-green);\n}\n\n.attachment-summary__item--file .attachment-summary__icon {\n  background: var(--fg-bg-warm);\n  color: var(--fg-orange-warn);\n}\n\n.attachment-summary__item--uploading .attachment-summary__icon {\n  background: var(--fg-bg-content);\n  color: var(--fg-text-gray);\n}\n\n.attachment-summary__item--project .attachment-summary__icon {\n  background: var(--fg-bg-step-active);\n  color: var(--fg-text-purple);\n}\n\n.attachment-summary__info {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.attachment-summary__name {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--fg-text-basic);\n  line-height: 1.3;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.attachment-summary__meta {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 11px;\n  color: var(--fg-text-gray);\n}\n\n.attachment-summary__type {\n  display: inline-flex;\n  align-items: center;\n  padding: 1px 6px;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n}\n\n.attachment-summary__type--template {\n  background: var(--fg-bg-litepp);\n  color: var(--fg-text-purple);\n}\n\n.attachment-summary__type--knowledge {\n  background: var(--fg-bg-tag-lime);\n  color: var(--fg-class-green);\n}\n\n.attachment-summary__type--file {\n  background: var(--fg-bg-warm);\n  color: var(--fg-orange-warn);\n}\n\n.attachment-summary__type--uploading {\n  background: var(--fg-bg-content);\n  color: var(--fg-text-gray);\n}\n\n.attachment-summary__type--project {\n  background: var(--fg-button);\n  color: #fff;\n}\n\n.attachment-summary__remove {\n  flex-shrink: 0;\n  display: inline-grid;\n  place-items: center;\n  width: 24px;\n  height: 24px;\n  background: transparent;\n  border: 0;\n  border-radius: 6px;\n  color: var(--fg-text-gray);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.attachment-summary__remove:hover {\n  background: var(--fg-bg-content);\n  color: var(--fg-anti-red);\n}\n\n.attachment-summary__empty {\n  padding: 24px 12px;\n  text-align: center;\n  font-size: 12px;\n  color: var(--fg-text-gray);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
